var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M498 1L499 2L498 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "none"
    },
    d: "M469 23L466 23L465 31L462 31C460.619 38.6325 456.253 46.7529 448 47C447.294 41.6625 444.325 36.8512 448 32L448 31L452 7C444.447 7.08405 442.048 11.2004 436.116 14.9854C432.049 17.5801 426.164 18.6284 422.853 22.189C416.771 28.7307 410.171 48.1516 409 57C393.548 54.8465 402 25.8973 402 15L388 21C386.62 27.7327 377.763 31.9844 372 35L371 47L368 47C367.786 51.9758 366.339 68.9349 359.84 70.0833C357.62 70.4756 355.063 67.6978 353 67L352 29L351 29L340 37C338.278 45.4 328.329 46.3414 324.843 53.5186C320.178 63.125 324.448 79.0106 316.995 87.473C313.912 90.9725 310.215 85.671 309.38 82.9599C307.052 75.404 308 66.7946 308 59L305 59L305 49C295.382 51.3051 296.194 57.0494 291.263 63.6605C288.352 67.5636 283.326 69.5121 281.147 74.1288C276.003 85.0244 276.94 101.106 276 113C262.969 111.997 261.458 85.0219 259 75C251.285 78.3592 250.161 83.8625 246.432 90.331C243.724 95.0293 238.053 97.9257 236.474 103.3C233.102 114.772 237.531 129.103 236 141C224.742 139.258 219.345 114.712 218 105C207.046 106.459 208.323 112.545 205.235 120.7C203.43 125.466 198.4 128.517 196.818 133.424C195.747 136.747 197.609 145.235 198.259 148.83C199.07 153.315 203.853 167.843 200.392 171.258C196.656 174.943 192.024 170.943 190.094 167.571C186.297 160.936 184.371 153.076 180.804 146.199C179.514 143.712 177.886 139.595 174.28 140.847C168.854 142.732 168.7 151.399 167.272 155.711C165.665 160.559 160.561 165.812 160.519 171.001C160.414 184.195 170.951 198.074 166 211L165 211L164 211L141 177L140 177L140 180C129.701 181.183 134.933 188.354 133.522 194.833C132.498 199.531 128.697 203.222 128.13 208.089C127.063 217.242 134.015 227.944 136.981 236.428C138.053 239.491 137.512 242.826 140 245L140 246L140 247L138 250C128.083 248.89 124.483 237.988 119.254 231.012C116.302 227.074 112.295 224.4 110 220L102 230C104.772 238.906 99.0783 244.329 99.7647 252.961C100.475 261.891 108.421 273.664 112.196 281.804C113.386 284.37 115.927 292.112 111.036 292.748C107.986 293.144 104.553 288.213 102.536 286.414C95.245 279.908 89.158 266.191 78 267L74 277C81.9411 283.212 74.3892 292.507 76.2778 300.816C79.4197 314.637 93.9474 322.641 94 338L90 338L90 342L76 342L76 343C80.0456 346.135 89.2801 364.149 77.1551 361.447C67.2845 359.247 61.413 347.126 52.4823 342.843C46.7831 340.111 42.4008 343.305 42 349L46 349C46.9424 356.168 44.1885 364.777 46.5093 371.675C50.1007 382.349 62.3882 389.344 68.25 398.746C70.3948 402.186 70.6883 408.087 65.8256 409.432C59.8474 411.085 52.5905 403.865 48.6528 400.383C42.4875 394.932 36.1787 392.006 28 392L32 419C39.9841 427.756 52.5945 437.437 58.4321 447.669C63.0653 455.79 54.8615 459.291 49 454L48 454C44.5708 455.66 42.0006 451.49 38.9861 449.818C31.9019 445.889 24.2152 442.091 16 442C16.0858 449.63 20.9002 449.23 23.3974 455.188C26.1255 461.698 21.7053 468.333 27.5448 473.942C34.8893 480.997 51.0235 488.548 54.8781 498.249C56.5487 502.454 50.7341 506.062 47.1551 505.49C39.4 504.251 24.7684 499.208 19 494L18 494L14 496L14 503C22.2183 506.291 20.7248 516.745 24.5486 523.741C25.9174 526.245 28.5635 527.486 30 530C36.3486 531.286 52.9274 540.554 54.8819 547.201C57.0518 554.579 49.243 555.827 45 552L44 552L33.9105 550.129L12 550C12.6613 553.814 14.2594 554.57 18 555C19.8292 560.407 24.077 570.842 27.875 575.141C34.3783 582.503 54.8677 591.579 64 595L62 604L59 602L58 602C53.2973 605.233 37.4717 601.444 33 598L32 598L20 600L22 608C29.3484 609.506 32.0636 617.204 33 624L72 640L72 650L53 648L52 648L39.1119 648.701L29 652L29 656L41 660L41 664C44.3175 665.899 45.6294 670.179 49.304 671.486C61.3865 675.783 81.1528 672 94 672L94 676C78.9895 676.052 66.2601 677.837 52 682L56 688L56 692L66 692C68.6588 710.245 99.6062 711.951 114 712L116 721L104 722L104 725C96.7934 725 80.9966 722.352 77.0432 730.404C75.9343 732.662 77.3004 734.749 79.0586 736.197C84.0392 740.298 92.7302 748.375 98.5177 751.157C102.491 753.067 107.706 751.629 111.961 752.129C121.301 753.225 130.68 754.767 140 756L140 762L122 766L122 769C117.537 769.012 93.2568 772.383 102.407 781.601C106.124 785.345 109.601 781.309 113.497 783.332C118.407 785.881 123.87 792.234 128 796L129 796L134 796L135 796L136 796C142.822 790.832 159.565 794 168 794C167.981 799.315 167.777 802.795 162 804L162 807L150 808L150 811L140 812L140 815C132.219 815.896 134.034 821.399 138 826L139 826L140 826C145.962 821.683 153.263 831.944 159.289 833.54C171.476 836.767 187.307 830 200 830L202 839L194 840L194 843L186 844L186 847L180 851L172 852C170.709 855.481 165.39 863.906 173.005 864.282C175.472 864.404 177.33 862.251 179.87 862.642C183.422 863.189 186.217 865.609 190 866L190 869L238 862C240.885 874.942 224.139 876.491 216.347 883.383C213.853 885.59 207.12 890.466 209.333 894.275C212.378 899.517 217.334 895.512 221.829 896.478C227.111 897.614 232.187 902.319 237.87 901.687C247.782 900.583 277.407 879.189 278 899L254 915L248 925L248 926L264.804 924.971L282.576 927.272L318 912C320.304 929.525 300.343 935.182 294 951C298.153 951.127 302.629 952.877 304 948L312 948L312 951C319.685 951.005 332.673 953.525 336 944C341.507 943.147 354.582 934.581 358 930L359 930L360 930C368.012 946.459 345.803 955.83 342 972L357.09 968.299L378 967L384 963L392 952C396.804 951.452 400.489 948.652 402 944L409 944C409.643 949.095 411.096 954.023 406 957L392 984L397 987L406 983L406 980L426 979L450 952L457 955L457 965L454 965L450 971L446 977L445 985L442 985L441 996C445.037 995.963 448.517 996.218 450 992L456 988L472 987L472 984C480.162 983.069 495.515 963.65 498 956L503 956L503 973L500 973L499 981L496 981C495.188 987.388 488.145 998.232 498 999L498 996L506 995C508.318 991.032 511.682 991.039 516 991L516 988L526 987L544 956L551 956L551 973L548 973L547 981L544 981L543 999L548 999L548 996L556 995C556.478 988.736 560.219 987.477 566 987L566 984L574 983L577 980L578 972L581 972L582 964L585 964L586 956L589 956C590.303 951.708 592.735 951.139 597 951L593 991L596 988L604 987C605.967 981.711 608.216 979.318 614 979L614 976L622 975L632 947L635 947C635.192 939.062 642.908 935.687 643.816 945.12C644.901 956.387 641 968.511 641 980L655 976L659 964C668.665 963.121 671.975 956.92 672 948L675 948L676 934L679 934L680 922L687 922L689 960L700.137 956.137L708 947L716.161 937.485L723 902L729 902L735 940C745.361 936.017 743.248 932.46 749.388 925.04C753.485 920.089 759.837 915.768 760.857 908.911C762.298 899.212 755.667 879.142 769 877L777 912L778 912L786.137 907.852L790.279 898.518L800.522 884.704L801 865C797.807 859.017 798.642 852.154 801 846L802 846L803 846C805.322 850.767 809.187 854.875 810.54 860.171C812.041 866.044 810.697 877.527 817.264 880.947C827.39 886.22 826.604 871.583 828.573 867.662C830.842 863.14 835.597 858.774 836.722 853.816C839.268 842.592 833 827.732 833 816C843.323 816.708 848.992 837.145 851 846C862.575 845.96 860.692 840.979 863.509 832.184C865.13 827.123 869.788 823.321 870.735 817.833C871.742 812.001 868.064 804.796 866.925 799.075C866.11 794.978 861.697 786.347 864.333 782.587C867.438 778.157 871.705 784.105 873.182 786.804C876.707 793.245 881.511 812.479 892.481 807.157C899.358 803.82 894.501 798.427 895.279 793.086C896.034 787.894 901.287 783.545 900.687 778.13C899.284 765.477 889.449 754.85 891 742C898.425 742.509 903.895 751.033 905 758L916 768L917 768C920.757 764.569 926.655 758.942 921 754L921 753L921 752C937.066 738.327 913.002 715.3 913 700C923.915 700.327 933.063 716.393 940 724L941 724L947 722L945.073 707.011L946.271 688.44L937 672L931 672L931 664C937.057 664.146 941.144 666.58 944 672L961 672C961 667.332 963.458 658.639 961.817 654.626C955.774 639.848 940.811 634.825 945 617C958.645 620.541 963.928 632.875 979 633L975 618L975 617L975 616L977 609L977 608L960.666 590.333L953.315 581.896L955 571C969.242 571.946 977.977 588.567 993 585C991.978 581.293 988.733 579.357 987.505 575.816C985.627 570.397 986.688 562.53 983.722 557.76C979.329 550.694 969.912 545.611 964 539.667C961.095 536.746 956.058 530.69 961.318 527.179C968.988 522.059 987.45 534.803 997 535C996.692 530.624 995.448 528.654 991 528L989 508C980.503 506.073 969.369 497.138 963.334 490.999C959.011 486.601 957.702 481.19 964.601 478.478C969.759 476.449 975.725 480.648 980.439 482.272C986.252 484.275 992.889 484.996 999 485L999 480C989.077 477.445 992.491 467.569 987.197 461.058C980.663 453.022 967.689 452.012 960.04 445.612C956.538 442.682 952.746 437.044 956.893 432.893C962.806 426.977 972.899 433.591 979.17 434.741C983.601 435.553 988.506 435 993 435L993 430C986.611 428.329 982.556 416.065 981 410L947 398C947.003 371.225 975.55 396.035 987 384L985 380C975.046 379.317 975.893 368.504 969.125 363.314C961.624 357.562 947.786 359.384 939.515 354.736C934.982 352.189 931.531 347.657 935 343L935 342C928.882 340.084 928.685 333.34 935.174 331.475C941.15 329.756 946.904 333.367 952.961 332.946C959.064 332.522 963.409 328.435 969 327L969 326C965.405 323.457 960.386 322.076 957.398 318.945C954.157 315.549 952.542 309.257 948.432 306.842C941.803 302.945 931.442 303.247 923.996 301.411C919.908 300.402 910.973 299.343 911.789 293.1C912.195 289.99 916.527 288.136 919.171 287.46C927.969 285.208 937.906 285.027 947 283C946.161 277.243 942.559 276.666 938.441 273.519C934.423 270.449 931.478 264.739 926.741 262.727C914.165 257.387 889.066 265.539 889 247C897.071 245.932 918.42 245.552 921 237L925 237C922.005 230.797 917.42 232.481 912.326 229.442C908.591 227.214 906.414 222.733 902.482 220.843C894.783 217.142 880.475 220.142 872.001 219.995C868.032 219.927 859.664 217.247 862.408 211.479C867.763 200.224 888.724 205.804 895 193L890 189L885 192L879 188L875 181C862.06 179.4 848.377 187.023 836.055 183.682C824.083 180.437 837.225 169.164 844 169L844 166C849.016 165.659 857.463 163.258 859 158L865 157C860.806 151.162 853.615 152.521 847 152C842.309 135.949 815.396 151.812 806 151.958C793.556 152.152 798.105 140.825 804.412 136.065C807.384 133.822 811.113 133.417 814.259 131.338C818.753 128.368 822.682 125.153 827 122L827 121C822.505 119.355 817.776 119.533 813.439 117.932C808.826 116.229 803.248 111.293 798.12 111.719C790.56 112.347 767.491 128.922 762.032 119.772C756.216 110.025 775.05 102.567 780.155 97.946C782.104 96.1815 788.571 91.0842 785.207 88.0324C782.639 85.7031 778.057 89.0018 775.075 88.6868C769.774 88.1269 763.366 82.3391 758.246 83.5525C747.889 86.007 737.893 97.5477 727.012 97.6867C714.762 97.8431 724.71 82.5869 729.129 79.4591C735.716 74.796 740.791 69.9399 745 63C739.598 62.2213 734.193 63.3604 729 62.4707C725.051 61.7942 719.288 58.569 715.385 59.8681C708.128 62.2834 699.015 67.8736 692.76 72.2346C689.763 74.3238 687.307 78.2723 683.09 77.1891C677.77 75.8223 677.617 70.1876 679.75 66.1705C684.343 57.5193 693.466 47.2336 700 40L700 39C694.723 39.0041 690.784 41.3574 685.88 41.8163C679.986 42.3681 673.346 39.184 667.514 41.8387C661.882 44.4026 658.078 49.4833 653 52.7678C648.745 55.5201 642.171 65.7693 636.768 60.7314C628.13 52.6783 642.858 39.8756 647.29 33.9159C648.937 31.701 653.521 25.7036 649.549 23.6042C645.436 21.4307 640.926 25.4282 637.036 26.1427C630.928 27.2643 626.441 23.5872 620.236 27.2507C611.011 32.6973 605.528 46.0558 595.678 50.1381C591.341 51.9356 588.016 48.15 588.184 43.9854C588.459 37.1396 593.504 31.1512 597.286 25.9159C600.368 21.6489 600.839 16.0391 604 12L604 11C597.703 7.73889 595.511 12.3529 589.711 14.2716C583.467 16.3367 575.556 17.5381 569 19C567.286 25.657 553.35 42.9501 546.576 45.4437C543.31 46.6459 540.935 41.3925 540.589 38.8688C539.098 28.0168 551.25 16.2961 552 5C545.178 5.00531 542.547 7.54816 536.561 9.94525C532.759 11.4678 528.73 10.854 525.015 12.8225C517.023 17.0573 514.122 26.2713 509.269 33.2685C506.695 36.9793 501.483 46.651 495.894 41.1057C492.883 38.1193 493.999 32.5836 495.005 29.0008C497.69 19.4316 501.992 11.1744 502 1C495.369 2.58905 491.492 7.4566 485.675 10.1574C478.268 13.5964 470.139 12.7357 469 23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb",
      stroke: "none"
    },
    d: "M502 1L502 10L503 10L502 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5",
      stroke: "none"
    },
    d: "M494 2L495 3L494 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M495 2L495 3L498 3L495 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a1a",
      stroke: "none"
    },
    d: "M498 2L499 3L498 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171717",
      stroke: "none"
    },
    d: "M494.333 3.66669L494.667 4.33331L494.333 3.66669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M542 5L543 6L542 5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eeeeee",
      stroke: "none"
    },
    d: "M444 6L445 7L444 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M445 6L445 7L452 7L445 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M452 6L453 7L452 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M488 6L489 7L488 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M489.667 6.33331L490.333 6.66669L489.667 6.33331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M540 6L541 7L540 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M541 6L542 7L541 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d5d5d",
      stroke: "none"
    },
    d: "M542 6L543 7L542 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M444.333 7.66669L444.667 8.33331L444.333 7.66669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aeaeae",
      stroke: "none"
    },
    d: "M452.333 7.66669L452.667 8.33331L452.333 7.66669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8c8c",
      stroke: "none"
    },
    d: "M488.333 7.66669L488.667 8.33331L488.333 7.66669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M540 7L541 8L540 7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M540 8L541 9L540 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M486 9L487 10L486 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M536 9L537 10L536 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M440 10L441 11L440 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M441 10L442 11L441 10M479 10L479 11L486 11L479 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M486 10L487 11L486 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M500.667 10.3333L501.333 10.6667L500.667 10.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M502 10L503 11L502 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M526 10L527 11L526 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M527 10L527 11L536 11L527 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M536 10L537 11L536 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M550 10L551 11L550 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M551 10L552 11L551 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M594 10L595 11L594 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M595.667 10.3333L596.333 10.6667L595.667 10.3333M602.667 10.3333L603.333 10.6667L602.667 10.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M604 10L605 11L604 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3d",
      stroke: "none"
    },
    d: "M440.333 11.6667L440.667 12.3333L440.333 11.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M478 11L479 12L478 11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M526.333 11.6667L526.667 12.3333L526.333 11.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M550 11L550 16L551 16L550 11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd",
      stroke: "none"
    },
    d: "M594.333 11.6667L594.667 12.3333L594.333 11.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M604 11L605 12L604 11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M478 12L479 13L478 12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M602 12L603 13L602 12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8c8c",
      stroke: "none"
    },
    d: "M603 12L604 13L603 12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M604 12L605 13L604 12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M522 13L523 14L522 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6b6b6",
      stroke: "none"
    },
    d: "M590 13L591 14L590 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353535",
      stroke: "none"
    },
    d: "M602 13L602 16L603 16L602 13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M396 14L396 15L402 15L396 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M434 14L435 15L434 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M435 14L435 15L438 15L435 14M472.667 14.3333L473.333 14.6667L472.667 14.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M520 14L521 15L520 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M521 14L522 15L521 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343",
      stroke: "none"
    },
    d: "M522 14L523 15L522 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M578 14L579 15L578 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M579 14L579 15L590 15L579 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M590 14L591 15L590 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b2b2",
      stroke: "none"
    },
    d: "M434 15L435 16L434 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M520 15L521 16L520 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2a2a2",
      stroke: "none"
    },
    d: "M578 15L579 16L578 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555",
      stroke: "none"
    },
    d: "M434 16L435 17L434 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      stroke: "none"
    },
    d: "M470.667 16.3333L471.333 16.6667L470.667 16.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M520 16L521 17L520 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8",
      stroke: "none"
    },
    d: "M550 16L551 17L550 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a8a8a",
      stroke: "none"
    },
    d: "M576 16L577 17L576 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      stroke: "none"
    },
    d: "M577 16L578 17L577 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d4d4d",
      stroke: "none"
    },
    d: "M578 16L579 17L578 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M602 16L603 17L602 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070",
      stroke: "none"
    },
    d: "M394 17L395 18L394 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M430 17L431 18L430 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M450 17L450 20L451 20L450 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M518 17L519 18L518 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M390 18L391 19L390 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M391 18L391 19L394 19L391 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M394 18L395 19L394 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M426 18L426 19L430 19L426 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M430 18L431 19L430 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M468 18L469 19L468 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M469 18L470 19L469 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M498.667 18.3333L499.333 18.6667L498.667 18.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M516 18L517 19L516 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M517 18L518 19L517 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    d: "M518 18L519 19L518 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M548 18L549 19L548 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M569 18L569 19L573 19L569 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M600 18L601 19L600 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M390 19L391 20L390 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6c6c",
      stroke: "none"
    },
    d: "M468 19L468 23L469 23L468 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M498 19L498 22L499 22L498 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M516 19L516 23L517 23L516 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M600 19L600 23L601 23L600 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      stroke: "none"
    },
    d: "M390 20L391 21L390 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M450 20L451 21L450 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      stroke: "none"
    },
    d: "M422.333 21.6667L422.667 22.3333L422.333 21.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M546 21L546 24L547 24L546 21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M496 22L497 23L496 22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M497 22L498 23L497 22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M420 23L420 29L421 29L420 23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M514.333 23.6667L514.667 24.3333L514.333 23.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M566.333 23.6667L566.667 24.3333L566.333 23.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M598 23L599 24L598 23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M448 24L449 25L448 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797979",
      stroke: "none"
    },
    d: "M449 24L450 25L449 24M544.667 24.3333L545.333 24.6667L544.667 24.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M546 24L547 25L546 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M598 24L599 25L598 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d",
      stroke: "none"
    },
    d: "M642 24L643 25L642 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686",
      stroke: "none"
    },
    d: "M651 24L652 25L651 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M652 24L653 25L652 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636363",
      stroke: "none"
    },
    d: "M386.333 25.6667L386.667 26.3333L386.333 25.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M448.333 25.6667L448.667 26.3333L448.333 25.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4b4b4",
      stroke: "none"
    },
    d: "M512 25L512 28L513 28L512 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      stroke: "none"
    },
    d: "M622.333 25.6667L622.667 26.3333L622.333 25.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M638 25L639 26L638 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M652.333 25.6667L652.667 26.3333L652.333 25.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M597 26L598 27L597 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M633 26L633 27L638 27L633 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      stroke: "none"
    },
    d: "M464 27L464 31L465 31L464 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "none"
    },
    d: "M562.333 27.6667L562.667 28.3333L562.333 27.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M596 27L597 28L596 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5",
      stroke: "none"
    },
    d: "M618.333 27.6667L618.667 28.3333L618.333 27.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M446.667 28.3333L447.333 28.6667L446.667 28.3333M495 28L496 29L495 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M512 28L513 29L512 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M594 28L595 29L594 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M595 28L596 29L595 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb",
      stroke: "none"
    },
    d: "M596 28L597 29L596 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      stroke: "none"
    },
    d: "M650 28L651 29L650 28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272727",
      stroke: "none"
    },
    d: "M350.333 29.6667L350.667 30.3333L350.333 29.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797",
      stroke: "none"
    },
    d: "M418 29L418 32L419 32L418 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M494 29L494 41L495 41L494 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M510 29L510 32L511 32L510 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M650.333 29.6667L650.667 30.3333L650.333 29.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M542 30L543 31L542 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eeeeee",
      stroke: "none"
    },
    d: "M543 30L544 31L543 30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M346 31L347 32L346 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M542 31L542 35L543 35L542 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M558 31L558 34L559 34L558 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M592 31L592 35L593 35L592 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M614.333 31.6667L614.667 32.3333L614.333 31.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M648 31L648 34L649 34L648 31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M345 32L346 33L345 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M346 32L347 33L346 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585858",
      stroke: "none"
    },
    d: "M418 32L419 33L418 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#181818",
      stroke: "none"
    },
    d: "M446 32L447 33L446 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6c6c",
      stroke: "none"
    },
    d: "M447 32L448 33L447 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M508 32L509 33L508 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M509 32L510 33L509 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M510 32L511 33L510 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M353 33L353 52L354 52L353 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f4f4f",
      stroke: "none"
    },
    d: "M374.333 33.6667L374.667 34.3333L374.333 33.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M416 33L416 39L417 39L416 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393939",
      stroke: "none"
    },
    d: "M446 33L447 34L446 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M508.333 33.6667L508.667 34.3333L508.333 33.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec",
      stroke: "none"
    },
    d: "M446 34L447 35L446 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M558 34L559 35L558 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M647 34L648 35L647 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M648 34L649 35L648 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M342 35L343 36L342 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M460.333 35.6667L460.667 36.3333L460.333 35.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b2b2b",
      stroke: "none"
    },
    d: "M506 35L506 38L507 38L506 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M540 35L541 36L540 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M556 35L557 36L556 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M590 35L590 39L591 39L590 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M610.333 35.6667L610.667 36.3333L610.333 35.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      stroke: "none"
    },
    d: "M646 35L647 36L646 35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M341 36L342 37L341 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f0f0f",
      stroke: "none"
    },
    d: "M342 36L343 37L342 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M540 36L541 37L540 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M556 36L557 37L556 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c2c2c",
      stroke: "none"
    },
    d: "M644 36L645 37L644 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      stroke: "none"
    },
    d: "M645 36L646 37L645 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M646 36L647 37L646 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M554.333 37.6667L554.667 38.3333L554.333 37.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M644.333 37.6667L644.667 38.3333L644.333 37.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b2b2",
      stroke: "none"
    },
    d: "M504 38L505 39L504 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M505 38L506 39L505 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M506 38L507 39L506 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M370 39L370 47L371 47L370 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M414 39L414 43L415 43L414 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7a7a7",
      stroke: "none"
    },
    d: "M504 39L505 40L504 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M540 39L541 40L540 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M552 39L553 40L552 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M606.333 39.6667L606.667 40.3333L606.333 39.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M642 39L643 40L642 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M700 39L701 40L700 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      stroke: "none"
    },
    d: "M504 40L505 41L504 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M540 40L541 41L540 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M541 40L542 41L541 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9",
      stroke: "none"
    },
    d: "M542 40L543 41L542 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M552 40L553 41L552 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4b4b4b",
      stroke: "none"
    },
    d: "M588 40L589 41L588 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b2b2b",
      stroke: "none"
    },
    d: "M640 40L641 41L640 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M641 40L642 41L641 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f6f6",
      stroke: "none"
    },
    d: "M642 40L643 41L642 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M670 40L671 41L670 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M671 40L672 41L671 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M672 40L673 41L672 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4c4c4",
      stroke: "none"
    },
    d: "M690 40L691 41L690 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M698 40L699 41L698 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M699 40L700 41L699 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M700 40L701 41L700 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#131313",
      stroke: "none"
    },
    d: "M338.333 41.6667L338.667 42.3333L338.333 41.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M456 41L456 45L457 45L456 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M502.333 41.6667L502.667 42.3333L502.333 41.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M542 41L542 45L543 45L542 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M550.333 41.6667L550.667 42.3333L550.333 41.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcbcb",
      stroke: "none"
    },
    d: "M588 41L588 48L589 48L588 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M604.333 41.6667L604.667 42.3333L604.333 41.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M640.333 41.6667L640.667 42.3333L640.333 41.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c2c2c",
      stroke: "none"
    },
    d: "M684 41L685 42L684 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M686 41L687 42L686 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#949494",
      stroke: "none"
    },
    d: "M698 41L698 44L699 44L698 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M684 42L685 43L684 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252525",
      stroke: "none"
    },
    d: "M685 42L686 43L685 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M686 42L687 43L686 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M412 43L412 47L413 47L412 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      stroke: "none"
    },
    d: "M548 43L549 44L548 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M602.333 43.6667L602.667 44.3333L602.333 43.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M638 43L638 47L639 47L638 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M664.333 43.6667L664.667 44.3333L664.333 43.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      stroke: "none"
    },
    d: "M448 44L449 45L448 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      stroke: "none"
    },
    d: "M548 44L549 45L548 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M696 44L697 45L696 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M697 44L698 45L697 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M698 44L699 45L698 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888",
      stroke: "none"
    },
    d: "M332.333 45.6667L332.667 46.3333L332.333 45.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M448 45L449 46L448 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M454.333 45.6667L454.667 46.3333L454.333 45.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M546 45L547 46L546 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M600.333 45.6667L600.667 46.3333L600.333 45.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#181818",
      stroke: "none"
    },
    d: "M696 45L696 48L697 48L696 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M448 46L449 47L448 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c2c2c",
      stroke: "none"
    },
    d: "M449 46L450 47L449 46M544.667 46.3333L545.333 46.6667L544.667 46.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#131313",
      stroke: "none"
    },
    d: "M546 46L547 47L546 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M330 47L331 48L330 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a8a8a",
      stroke: "none"
    },
    d: "M410 47L410 52L411 52L410 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M598.333 47.6667L598.667 48.3333L598.333 47.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c7c7c",
      stroke: "none"
    },
    d: "M636 47L636 51L637 51L636 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec",
      stroke: "none"
    },
    d: "M329 48L330 49L329 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M330 48L331 49L330 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M588 48L589 49L588 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M658 48L659 49L658 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313131",
      stroke: "none"
    },
    d: "M694 48L695 49L694 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M695 48L696 49L695 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M696 48L697 49L696 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M305 49L305 59L306 59L305 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M590.333 49.6667L590.667 50.3333L590.333 49.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M596.333 49.6667L596.667 50.3333L596.333 49.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M656.333 49.6667L656.667 50.3333L656.333 49.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M694.333 49.6667L694.667 50.3333L694.333 49.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M692 51L693 52L692 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M352 52L353 53L352 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585858",
      stroke: "none"
    },
    d: "M353 52L354 53L353 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M410 52L411 53L410 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M654 52L655 53L654 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M690 52L691 53L690 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M691 52L692 53L691 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M692 52L693 53L692 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M366 53L366 60L367 60L366 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M408 53L408 56L409 56L408 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M690.333 53.6667L690.667 54.3333L690.333 53.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M404.333 55.6667L404.667 56.3333L404.333 55.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797",
      stroke: "none"
    },
    d: "M648.333 55.6667L648.667 56.3333L648.333 55.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M688 55L689 56L688 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M352 56L353 57L352 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M353 56L354 57L353 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M406.667 56.3333L407.333 56.6667L406.667 56.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M408 56L409 57L408 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M686 56L687 57L686 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M687 56L688 57L687 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M688 56L689 57L688 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M292 57L292 63L293 63L292 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M353 57L353 67L354 67L353 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M686 57L687 58L686 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121",
      stroke: "none"
    },
    d: "M684 58L685 59L684 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M685 58L686 59L685 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M686 58L687 59L686 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c7c7c",
      stroke: "none"
    },
    d: "M636.333 59.6667L636.667 60.3333L636.333 59.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M644 59L645 60L644 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c2c2c",
      stroke: "none"
    },
    d: "M684 59L685 60L684 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313131",
      stroke: "none"
    },
    d: "M366 60L367 61L366 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M643 60L644 61L643 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M644 60L645 61L644 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M682 60L683 61L682 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3d",
      stroke: "none"
    },
    d: "M683 60L684 61L683 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M684 60L685 61L684 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M713.667 60.3333L714.333 60.6667L713.667 60.3333M719 60L719 61L725 61L719 60M737 60L738 61L737 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M738 60L739 61L738 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M364.667 61.3333L365.333 61.6667L364.667 61.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M636 61L637 62L636 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M637 61L638 62L637 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M638.333 61.6667L638.667 62.3333L638.333 61.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#131313",
      stroke: "none"
    },
    d: "M642 61L643 62L642 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M682 61L682 64L683 64L682 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M711.667 61.3333L712.333 61.6667L711.667 61.3333M725 61L725 62L728 62L725 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M728 61L729 62L728 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M735.667 61.3333L736.333 61.6667L735.667 61.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M738 61L739 62L738 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M739.667 61.3333L740.333 61.6667L739.667 61.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaaaaa",
      stroke: "none"
    },
    d: "M640 62L641 63L640 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M641 62L642 63L641 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040404",
      stroke: "none"
    },
    d: "M642 62L643 63L642 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M728 62L729 63L728 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M290.667 64.3333L291.333 64.6667L290.667 64.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M680 64L681 65L680 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M681 64L682 65L681 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M682 64L683 65L682 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M705.667 64.3333L706.333 64.6667L705.667 64.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M744 64L745 65L744 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M288 65L289 66L288 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M289 65L290 66L289 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M680 65L681 66L680 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M704.333 65.6667L704.667 66.3333L704.333 65.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M743 65L744 66L743 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M744 65L745 66L744 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M288 66L289 67L288 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M362 66L363 67L362 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d4d4d",
      stroke: "none"
    },
    d: "M363 66L364 67L363 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b2b2",
      stroke: "none"
    },
    d: "M679 66L680 67L679 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M680 66L681 67L680 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353535",
      stroke: "none"
    },
    d: "M742 66L743 67L742 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b3b3b",
      stroke: "none"
    },
    d: "M362 67L363 68L362 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M678 67L678 75L679 75L678 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M700 67L701 68L700 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M742 67L743 68L742 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      stroke: "none"
    },
    d: "M285 68L286 69L285 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M361 68L362 69L361 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M362 68L363 69L362 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M699 68L700 69L699 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M700 68L701 69L700 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M741 68L742 69L741 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M742 68L743 69L742 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M284 69L285 70L284 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M285 69L286 70L285 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M356 69L357 70L356 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M357 69L358 70L357 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M361 69L362 70L361 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M696 69L697 70L696 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M697.667 69.3333L698.333 69.6667L697.667 69.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M283 70L284 71L283 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#131313",
      stroke: "none"
    },
    d: "M284 70L285 71L284 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M357 70L358 71L357 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545454",
      stroke: "none"
    },
    d: "M360 70L361 71L360 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M361 70L362 71L361 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M696 70L697 71L696 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M740 70L741 71L740 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M692 71L693 72L692 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#525252",
      stroke: "none"
    },
    d: "M738 71L739 72L738 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M281 72L282 73L281 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M321 72L322 73L321 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M691 72L692 73L691 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbcbc",
      stroke: "none"
    },
    d: "M692 72L693 73L692 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292929",
      stroke: "none"
    },
    d: "M737 72L738 73L737 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M738 72L739 73L738 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M280 73L281 74L280 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M281 73L282 74L281 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M321 73L322 74L321 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M279 74L280 75L279 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M280 74L281 75L280 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a5a5",
      stroke: "none"
    },
    d: "M320 74L321 75L320 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404040",
      stroke: "none"
    },
    d: "M321 74L322 75L321 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a8a8a",
      stroke: "none"
    },
    d: "M736 74L737 75L736 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M256 75L257 76L256 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313131",
      stroke: "none"
    },
    d: "M259 75L259 79L260 79L259 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M279 75L279 81L280 81L279 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M680 75L681 76L680 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9",
      stroke: "none"
    },
    d: "M688 75L689 76L688 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959",
      stroke: "none"
    },
    d: "M734 75L735 76L734 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M254.667 76.3333L255.333 76.6667L254.667 76.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M256 76L257 77L256 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c2c2c",
      stroke: "none"
    },
    d: "M680 76L681 77L680 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M681 76L682 77L681 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M682 76L683 77L682 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M686 76L687 77L686 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M687 76L688 77L687 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbcbc",
      stroke: "none"
    },
    d: "M688 76L689 77L688 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M733 76L734 77L733 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M734 76L735 77L734 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M682 77L683 78L682 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M683 77L683 78L686 78L683 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M686 77L687 78L686 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M732 77L733 78L732 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b3b3b",
      stroke: "none"
    },
    d: "M730 78L731 79L730 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      stroke: "none"
    },
    d: "M731 78L732 79L731 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M732 78L733 79L732 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M252.333 79.6667L252.667 80.3333L252.333 79.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M261 79L262 80L261 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M309 79L309 84L310 84L309 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M250.667 80.3333L251.333 80.6667L250.667 80.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M261 80L262 81L261 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M726 80L727 81L726 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M727.667 80.3333L728.333 80.6667L727.667 80.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M278 81L279 82L278 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232323",
      stroke: "none"
    },
    d: "M279 81L280 82L279 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      stroke: "none"
    },
    d: "M726.333 81.6667L726.667 82.3333L726.333 81.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M318.667 82.3333L319.333 82.6667L318.667 82.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M762 83L763 84L762 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M309 84L310 85L309 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M722 84L723 85L722 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M723.667 84.3333L724.333 84.6667L723.667 84.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M754 84L755 85L754 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaeaea",
      stroke: "none"
    },
    d: "M755.667 84.3333L756.333 84.6667L755.667 84.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M762 84L763 85L762 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaeaea",
      stroke: "none"
    },
    d: "M763.667 84.3333L764.333 84.6667L763.667 84.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M262 85L263 86L262 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f4f4f",
      stroke: "none"
    },
    d: "M263 85L264 86L263 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M722.333 85.6667L722.667 86.3333L722.333 85.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M753 85L754 86L753 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232323",
      stroke: "none"
    },
    d: "M754 85L755 86L754 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M765 85L766 86L765 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M766 85L767 86L766 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M263 86L263 91L264 91L263 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M310.667 86.3333L311.333 86.6667L310.667 86.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M766 86L767 87L766 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M767 86L768 87L767 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M768 86L769 87L768 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M772 87L773 88L772 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M779 87L780 88L779 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M786.333 87.6667L786.667 88.3333L786.333 87.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M247 88L248 89L247 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M312.667 88.3333L313.333 88.6667L312.667 88.3333M316.667 88.3333L317.333 88.6667L316.667 88.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M746 88L747 89L746 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M747.667 88.3333L748.333 88.6667L747.667 88.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M772 88L773 89L772 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M773 88L773 89L779 89L773 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M779 88L780 89L779 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M787 88L788 89L787 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      stroke: "none"
    },
    d: "M246 89L247 90L246 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M247 89L248 90L247 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      stroke: "none"
    },
    d: "M314.667 89.3333L315.333 89.6667L314.667 89.3333M745 89L746 90L745 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M746 89L747 90L746 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272727",
      stroke: "none"
    },
    d: "M787 89L788 90L787 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M788 89L789 90L788 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M787 90L788 91L787 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4c4c4",
      stroke: "none"
    },
    d: "M788 90L789 91L788 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M245 91L246 92L245 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M264 91L265 92L264 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M786 91L787 92L786 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M243 92L244 93L243 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M244 92L245 93L244 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M245 92L246 93L245 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M263 92L264 93L263 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M264 92L265 93L264 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M737 92L737 93L741 93L737 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M785 92L786 93L785 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M786 92L787 93L786 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3b3b3",
      stroke: "none"
    },
    d: "M243 93L244 94L243 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M263 93L263 99L264 99L263 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c7c7c",
      stroke: "none"
    },
    d: "M242 94L243 95L242 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M243 94L244 95L243 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545",
      stroke: "none"
    },
    d: "M784 94L785 95L784 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M722 95L723 96L722 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M782 95L783 96L782 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M240.667 96.3333L241.333 96.6667L240.667 96.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6c6c",
      stroke: "none"
    },
    d: "M722 96L723 97L722 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M729 96L729 97L733 97L729 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M781 96L782 97L781 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M782 96L783 97L782 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M723.667 97.3333L724.333 97.6667L723.667 97.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3b3b3",
      stroke: "none"
    },
    d: "M726 97L727 98L726 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M727.667 97.3333L728.333 97.6667L727.667 97.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M780 97L781 98L780 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M239 98L240 99L239 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M725 98L726 99L725 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M726 98L727 99L726 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      stroke: "none"
    },
    d: "M779 98L780 99L779 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4c4c4",
      stroke: "none"
    },
    d: "M780 98L781 99L780 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M265.333 99.6667L265.667 100.333L265.333 99.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M778.333 99.6667L778.667 100.333L778.333 99.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M236 101L237 102L236 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M237 101L238 102L237 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M774 101L775 102L774 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777777",
      stroke: "none"
    },
    d: "M773 102L774 103L773 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282",
      stroke: "none"
    },
    d: "M774 102L775 103L774 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b2b2b",
      stroke: "none"
    },
    d: "M276 103L276 109L277 109L276 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M772.333 103.667L772.667 104.333L772.333 103.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M267 105L267 109L268 109L267 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M768 105L769 106L768 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M212.667 106.333L213.333 106.667L212.667 106.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M766 106L767 107L766 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070",
      stroke: "none"
    },
    d: "M767 106L768 107L767 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M768 106L769 107L768 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M209.333 107.667L209.667 108.333L209.333 107.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M766.333 107.667L766.667 108.333L766.333 107.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M219 109L219 113L220 113L219 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4b4b4b",
      stroke: "none"
    },
    d: "M268 109L269 110L268 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M269 109L270 110L269 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M275 109L275 113L276 113L275 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M764 109L765 110L764 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M269 110L270 111L269 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111111",
      stroke: "none"
    },
    d: "M762 110L763 111L762 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M763 110L764 111L763 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcbcb",
      stroke: "none"
    },
    d: "M764 110L765 111L764 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M205 111L205 121L206 121L205 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M762.333 111.667L762.667 112.333L762.333 111.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6b6b",
      stroke: "none"
    },
    d: "M800.333 111.667L800.667 112.333L800.333 111.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M221 113L222 114L221 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b2b2",
      stroke: "none"
    },
    d: "M792 113L793 114L792 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M791 114L792 115L791 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M792 114L793 115L792 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M805.667 114.333L806.333 114.667L805.667 114.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M787.333 115.667L787.667 116.333L787.333 115.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M222 117L223 118L222 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a5a5",
      stroke: "none"
    },
    d: "M223 117L224 118L223 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M819 117L820 118L819 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M820.333 117.667L820.667 118.333L820.333 117.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M223 118L223 127L224 127L223 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a3a3",
      stroke: "none"
    },
    d: "M813.667 118.333L814.333 118.667L813.667 118.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M237 119L237 125L238 125L237 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b2b2b",
      stroke: "none"
    },
    d: "M775.333 119.667L775.667 120.333L775.333 119.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343",
      stroke: "none"
    },
    d: "M824.333 119.667L824.667 120.333L824.333 119.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M204 121L205 122L204 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M205 121L206 122L205 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111111",
      stroke: "none"
    },
    d: "M762 121L763 122L762 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M763 121L764 122L763 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcbcb",
      stroke: "none"
    },
    d: "M764 121L765 122L764 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M770 121L771 122L770 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M764 122L765 123L764 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M769 122L770 123L769 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M770 122L771 123L770 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M825.667 122.333L826.333 122.667L825.667 122.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343",
      stroke: "none"
    },
    d: "M824.333 123.667L824.667 124.333L824.333 123.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M201.333 125.667L201.667 126.333L201.333 125.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f4f4f",
      stroke: "none"
    },
    d: "M821.667 126.333L822.333 126.667L821.667 126.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M225.333 127.667L225.667 128.333L225.333 127.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M820.333 127.667L820.667 128.333L820.333 127.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M197 129L198 130L197 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M198 129L199 130L198 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313131",
      stroke: "none"
    },
    d: "M199 129L200 130L199 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M816 129L817 130L816 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M197 130L197 133L198 133L197 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M815 130L816 131L815 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M816 130L817 131L816 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      stroke: "none"
    },
    d: "M227 133L227 137L228 137L227 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M805 134L805 135L811 135L805 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M237.333 135.667L237.667 136.333L237.333 135.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M804.333 135.667L804.667 136.333L804.333 135.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M197 137L197 151L198 151L197 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M229 137L230 138L229 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b3b3b",
      stroke: "none"
    },
    d: "M801.667 138.333L802.333 138.667L801.667 138.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M173 139L174 140L173 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M174 139L174 140L177 140L174 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M177 139L178 140L177 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M230 139L231 140L230 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M231 139L232 140L231 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M799 139L800 140L799 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M800 139L801 140L800 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M173 140L174 141L173 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M177 140L178 141L177 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M231 140L232 141L231 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acacac",
      stroke: "none"
    },
    d: "M799 140L800 141L799 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M179 141L179 145L180 145L179 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      stroke: "none"
    },
    d: "M797.667 142.333L798.333 142.667L797.667 142.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M171 143L172 144L171 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959595",
      stroke: "none"
    },
    d: "M835 143L836 144L835 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M836 143L837 144L836 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M171 144L172 145L171 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M835 144L836 145L835 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M836 144L837 145L836 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M169.333 145.667L169.667 146.333L169.333 145.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M181 145L181 149L182 149L181 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M827 145L828 146L827 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828",
      stroke: "none"
    },
    d: "M840 145L841 146L840 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6b6b",
      stroke: "none"
    },
    d: "M827 146L828 147L827 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121",
      stroke: "none"
    },
    d: "M840 146L841 147L840 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M841 146L842 147L841 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M168 147L169 148L168 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M169 147L170 148L169 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M797.667 147.333L798.333 147.667L797.667 147.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M819 147L820 148L819 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M820 147L820 148L827 148L820 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M841 147L842 148L841 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M842.667 147.333L843.333 147.667L842.667 147.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M844 147L845 148L844 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M819 148L820 149L819 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M844 148L845 149L844 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M183.333 149.667L183.667 150.333L183.333 149.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acacac",
      stroke: "none"
    },
    d: "M799 149L800 150L799 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M811 149L812 150L811 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M799 150L800 151L799 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M800 150L801 151L800 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M811 150L812 151L811 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M183 151L184 152L183 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M184 151L185 152L184 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242",
      stroke: "none"
    },
    d: "M185 151L186 152L185 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M197 151L198 152L197 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M198 151L199 152L198 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M199 151L200 152L199 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M801 151L801 152L811 152L801 151M847 151L847 152L851 152L847 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M857 151L858 152L857 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M858.667 151.333L859.333 151.667L858.667 151.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121",
      stroke: "none"
    },
    d: "M860 151L861 152L860 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c2c2c",
      stroke: "none"
    },
    d: "M185 152L185 157L186 157L185 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6b6b",
      stroke: "none"
    },
    d: "M199 152L200 153L199 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      stroke: "none"
    },
    d: "M857 152L858 153L857 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M860 152L861 153L860 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M863.667 155.333L864.333 155.667L863.667 155.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M165 157L165 161L166 161L165 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M187 157L187 162L188 162L187 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M859 158L859 159L863 159L859 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M856 161L857 162L856 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M187 162L188 163L187 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M853 162L852 164L853 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#131313",
      stroke: "none"
    },
    d: "M854.667 162.333L855.333 162.667L854.667 162.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M856 162L857 163L856 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555",
      stroke: "none"
    },
    d: "M163 163L164 164L163 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M188 163L189 164L188 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M189 163L190 164L189 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M853 163L854 164L853 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M163 164L164 165L163 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M189 164L189 167L190 167L189 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M852 164L853 165L852 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M161 165L161 169L162 169L161 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M201 165L201 171L202 171L201 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M848 165L849 166L848 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M844 166L845 167L844 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M845 166L845 167L848 167L845 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M848 166L849 167L848 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M189 167L190 168L189 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M190 167L191 168L190 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M191 167L192 168L191 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M844.333 167.667L844.667 168.333L844.333 167.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M191.333 168.667L191.667 169.333L191.333 168.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec",
      stroke: "none"
    },
    d: "M837.333 169.667L837.667 170.333L837.333 169.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      stroke: "none"
    },
    d: "M191 170L192 171L191 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M835.667 170.333L836.333 170.667L835.667 170.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M192 171L193 172L192 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M193 171L194 172L193 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M200 171L201 172L200 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M201 171L202 172L201 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M193 172L194 173L193 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M161 173L161 181L162 181L161 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M832.333 173.667L832.667 174.333L832.333 173.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M141.333 177.667L141.667 178.333L141.333 177.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M136 179L136 180L140 180L136 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M141 179L142 180L141 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M142 179L143 180L142 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M143 179L144 180L143 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M831 179L832 180L831 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070",
      stroke: "none"
    },
    d: "M832 179L833 180L832 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M867 179L867 180L871 180L867 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M143 180L144 181L143 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M832 180L832 183L833 183L832 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M133 181L133 185L134 185L133 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M145 181L145 185L146 185L145 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M853.333 181.667L853.667 182.333L853.333 181.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M833 183L834 184L833 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M834 183L834 184L851 184L834 183M875.667 183.333L876.333 183.667L875.667 183.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M131 185L131 189L132 189L131 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      stroke: "none"
    },
    d: "M147.333 185.667L147.667 186.333L147.333 185.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M148 187L149 188L148 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M149 187L150 188L149 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M879 187L879 188L883 188L879 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M149 188L149 191L150 191L149 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M133 189L133 197L134 197L133 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555",
      stroke: "none"
    },
    d: "M890.333 189.667L890.667 190.333L890.333 189.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M149 191L150 192L149 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M150 191L151 192L150 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eeeeee",
      stroke: "none"
    },
    d: "M151 191L152 192L151 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M165 191L165 201L166 201L165 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393939",
      stroke: "none"
    },
    d: "M885 191L886 192L885 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M886 191L887 192L886 191M891.667 191.333L892.333 191.667L891.667 191.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M151 192L151 195L152 195L151 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M152 195L153 196L152 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M153 195L154 196L153 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M894 195L895 196L894 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M153 196L153 199L154 199L153 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M893 196L894 197L893 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8c8c",
      stroke: "none"
    },
    d: "M894 196L895 197L894 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M131 197L131 201L132 201L131 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292929",
      stroke: "none"
    },
    d: "M153 199L154 200L153 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6b6b",
      stroke: "none"
    },
    d: "M154 199L155 200L154 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      stroke: "none"
    },
    d: "M155 199L156 200L155 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M155 200L156 201L155 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M167.333 201.667L167.667 202.333L167.333 201.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M129.333 203.667L129.667 204.333L129.333 203.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M157.333 203.667L157.667 204.333L157.333 203.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M127 205L127 215L128 215L127 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M159.333 205.667L159.667 206.333L159.333 205.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878",
      stroke: "none"
    },
    d: "M160 207L161 208L160 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M161 207L162 208L161 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545454",
      stroke: "none"
    },
    d: "M161 208L162 209L161 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M165.333 209.667L165.667 210.333L165.333 209.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636363",
      stroke: "none"
    },
    d: "M861 211L862 212L861 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      stroke: "none"
    },
    d: "M862 211L863 212L862 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4c4c4",
      stroke: "none"
    },
    d: "M861 212L861 215L862 215L861 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M129 215L129 219L130 219L129 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M863.667 217.333L864.333 217.667L863.667 217.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaeaea",
      stroke: "none"
    },
    d: "M107 219L108 220L107 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M108.667 219.333L109.333 219.667L108.667 219.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M865 219L866 220L865 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M866 219L866 220L903 220C893.202 215.889 876.649 219 866 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M107 220L108 221L107 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M130 220L131 221L130 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M903 220L904 221L903 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959",
      stroke: "none"
    },
    d: "M105 221L106 222L105 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M106 221L107 222L106 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M107 221L108 222L107 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M110 221L111 222L110 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353535",
      stroke: "none"
    },
    d: "M111 221L112 222L111 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M131 221L132 222L131 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M903.667 221.333L904.333 221.667L903.667 221.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M105 222L106 223L105 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828",
      stroke: "none"
    },
    d: "M111 222L112 223L111 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M131 222L131 225L132 225L131 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M103 223L104 224L103 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M104 223L105 224L104 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M105 223L106 224L105 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171717",
      stroke: "none"
    },
    d: "M111 223L112 224L111 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M112 223L113 224L112 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M113 223L114 224L113 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M905 223L906 224L905 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M906 223L907 224L906 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M907 223L908 224L907 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M103 224L103 229L104 229L103 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a3a3",
      stroke: "none"
    },
    d: "M113 224L114 225L113 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M907 224L908 225L907 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M113 225L114 226L113 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M114 225L115 226L114 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      stroke: "none"
    },
    d: "M115 225L116 226L115 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M131 225L132 226L131 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M132 225L133 226L132 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M133 225L134 226L133 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M907 225L908 226L907 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M908 225L909 226L908 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121",
      stroke: "none"
    },
    d: "M115 226L116 227L115 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M133 226L133 231L134 231L133 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9d9d",
      stroke: "none"
    },
    d: "M117.333 227.667L117.667 228.333L117.333 227.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M909 227L910 228L909 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M910 227L911 228L910 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M911 227L912 228L911 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M911 228L912 229L911 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M102 229L103 230L102 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171717",
      stroke: "none"
    },
    d: "M103 229L104 230L103 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M117 229L118 230L117 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M118 229L119 230L118 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M911 229L912 230L911 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M912 229L913 230L912 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M119 231L120 232L119 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M120 231L121 232L120 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M121 231L122 232L121 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M921 231L922 232L921 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M922 231L923 232L922 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M102 232L103 233L102 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M121 232L121 235L122 235L121 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M922 232L923 233L922 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M923 232L924 233L923 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aeaeae",
      stroke: "none"
    },
    d: "M103 233L104 234L103 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M923.333 233.667L923.667 234.333L923.333 233.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M103 234L103 239L104 239L103 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M121 235L122 236L121 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M122 235L123 236L122 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171717",
      stroke: "none"
    },
    d: "M136 236L137 237L136 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M137 236L138 237L137 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M123 237L124 238L123 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383",
      stroke: "none"
    },
    d: "M137 237L137 243L138 243L137 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M921 237L922 238L921 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M922 237L922 238L925 238L922 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M123 238L124 239L123 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M921 238L922 239L921 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M102 239L103 240L102 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M103 239L104 240L103 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M123 239L124 240L123 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M124 239L125 240L124 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb",
      stroke: "none"
    },
    d: "M125 239L126 240L125 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M125 240L126 241L125 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f0f0f",
      stroke: "none"
    },
    d: "M919 240L920 241L919 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111111",
      stroke: "none"
    },
    d: "M920 240L921 241L920 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6b6b",
      stroke: "none"
    },
    d: "M101 241L102 242L101 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M125 241L126 242L125 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313131",
      stroke: "none"
    },
    d: "M126 241L127 242L126 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M918 241L919 242L918 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M919 241L920 242L919 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M101 242L101 245L102 245L101 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M918 242L919 243L918 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M127 243L128 244L127 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3b3b3",
      stroke: "none"
    },
    d: "M128 243L129 244L128 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M129 243L130 244L129 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M907.333 243.667L907.667 244.333L907.333 243.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M129 244L130 245L129 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M903 244L903 245L907 245L903 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M99 245L100 246L99 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M100 245L101 246L100 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M101 245L102 246L101 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M129 245L130 246L129 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M130 245L131 246L130 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M138 245L139 246L138 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M139 245L140 246L139 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070",
      stroke: "none"
    },
    d: "M893 245L894 246L893 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M894 245L894 246L903 246L894 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M99 246L99 251L100 251L99 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M139 246L140 247L139 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M893 246L894 247L893 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M131.333 247.667L131.667 248.333L131.333 247.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M137 247L138 248L137 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292929",
      stroke: "none"
    },
    d: "M889 247L890 248L889 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383",
      stroke: "none"
    },
    d: "M890 247L891 248L890 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M132 248L133 249L132 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M133 248L134 249L133 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383",
      stroke: "none"
    },
    d: "M137 248L138 249L137 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M889 248L890 249L889 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M133 249L134 250L133 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    d: "M134 249L134 250L137 250L134 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M137 249L138 250L137 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      stroke: "none"
    },
    d: "M889 249L890 250L889 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#949494",
      stroke: "none"
    },
    d: "M99 251L100 252L99 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M99 253L99 257L100 257L99 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M889 255L890 256L889 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada",
      stroke: "none"
    },
    d: "M890 255L891 256L890 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555",
      stroke: "none"
    },
    d: "M890 256L891 257L890 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M99 257L100 258L99 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3b3b3",
      stroke: "none"
    },
    d: "M100 257L101 258L100 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M101 257L102 258L101 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M891.667 257.333L892.333 257.667L891.667 257.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M101 258L101 261L102 261L101 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M909 259L909 260L915 260L909 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M915 259L916 260L915 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaeaea",
      stroke: "none"
    },
    d: "M915 260L916 261L915 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M102 261L103 262L102 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M103 261L104 262L103 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M918 261L919 262L918 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#525252",
      stroke: "none"
    },
    d: "M919 261L919 262L927 262L919 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M927 261L928 262L927 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M103 262L103 265L104 265L103 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M927 262L928 263L927 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M81 265L82 266L81 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959",
      stroke: "none"
    },
    d: "M82 265L83 266L82 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M83 265L84 266L83 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M103 265L104 266L103 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M104 265L105 266L104 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M105 265L106 266L105 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959",
      stroke: "none"
    },
    d: "M929.667 265.333L930.333 265.667L929.667 265.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M931 265L932 266L931 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M81 266L82 267L81 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M83 266L84 267L83 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M105 266L105 269L106 269L105 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M931 266L932 267L931 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d2d2",
      stroke: "none"
    },
    d: "M85.3333 267.667L85.6667 268.333L85.3333 267.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M75 269L76 270L75 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M76 269L77 270L76 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M77 269L78 270L77 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f4f4f",
      stroke: "none"
    },
    d: "M85 269L86 270L85 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M86 269L87 270L86 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M87 269L88 270L87 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M106 269L107 270L106 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M933.667 269.333L934.333 269.667L933.667 269.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M935 269L936 270L935 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M75 270L75 273L76 273L75 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M87 270L88 271L87 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M935 270L936 271L935 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcbcb",
      stroke: "none"
    },
    d: "M89.3333 271.667L89.6667 272.333L89.3333 271.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M107.333 271.667L107.667 272.333L107.333 271.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    d: "M75 273L76 274L75 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M89 273L90 274L89 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      stroke: "none"
    },
    d: "M90 273L91 274L90 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M91 273L92 274L91 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M107 273L108 274L107 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M108 273L109 274L108 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M109 273L110 274L109 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      stroke: "none"
    },
    d: "M937 273L938 274L937 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M938 273L939 274L938 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M91 274L92 275L91 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555",
      stroke: "none"
    },
    d: "M109 274L109 277L110 277L109 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M938 274L939 275L938 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M94 275L95 276L94 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M943.333 275.667L943.667 276.333L943.333 275.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M75.3333 277.667L75.6667 278.333L75.3333 277.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M95 277L96 278L95 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242",
      stroke: "none"
    },
    d: "M95 278L96 279L95 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M97.3333 279.667L97.6667 280.333L97.3333 279.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M111 279L111 283L112 283L111 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M97 281L98 282L97 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M98 281L99 282L98 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M99.3333 283.667L99.6667 284.333L99.3333 283.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M113.333 283.667L113.667 284.333L113.333 283.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M101 285L102 286L101 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      stroke: "none"
    },
    d: "M102 285L103 286L102 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M113 285L114 286L113 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M935 285L936 286L935 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858585",
      stroke: "none"
    },
    d: "M936 285L937 286L936 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M935 286L936 287L935 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      stroke: "none"
    },
    d: "M103 287L104 288L103 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M104 287L105 288L104 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M105 287L106 288L105 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M105 288L106 289L105 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M75 289L76 290L75 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      stroke: "none"
    },
    d: "M76 289L77 290L76 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M77 289L78 290L77 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959",
      stroke: "none"
    },
    d: "M105 289L106 290L105 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      stroke: "none"
    },
    d: "M106 289L107 290L106 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M75 290L75 303L76 303L75 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040404",
      stroke: "none"
    },
    d: "M107.667 291.333L108.333 291.667L107.667 291.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acacac",
      stroke: "none"
    },
    d: "M109 291L110 292L109 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M113 291L114 292L113 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M911 291L912 292L911 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M912 291L913 292L912 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaaaaa",
      stroke: "none"
    },
    d: "M109 292L110 293L109 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M113 292L114 293L113 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M911 292L911 296L912 296L911 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M109 293L110 294L109 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "none"
    },
    d: "M110 293L111 294L110 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M111 293L112 294L111 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d",
      stroke: "none"
    },
    d: "M913 297L914 298L913 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M914 297L915 298L914 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M914 298L915 299L914 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M914 299L915 300L914 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M915 299L915 300L921 300L915 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M921 300L922 301L921 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M923 301L924 302L923 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#949494",
      stroke: "none"
    },
    d: "M924 301L924 302L930 302L924 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M930 301L931 302L930 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M930 302L931 303L930 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f6f6",
      stroke: "none"
    },
    d: "M75 303L76 304L75 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M76.6667 303.333L77.3333 303.667L76.6667 303.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M930 303L931 304L930 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#181818",
      stroke: "none"
    },
    d: "M931 303L931 304L941 304L931 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2a2a2",
      stroke: "none"
    },
    d: "M79 305L79 309L80 309L79 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M943 305L943 306L949 306L943 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M949.667 307.333L950.333 307.667L949.667 307.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M81 309L82 310L81 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e1e1e1",
      stroke: "none"
    },
    d: "M951 309L952 310L951 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aeaeae",
      stroke: "none"
    },
    d: "M951 310L952 311L951 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9",
      stroke: "none"
    },
    d: "M82 311L83 312L82 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a1a",
      stroke: "none"
    },
    d: "M951 311L952 312L951 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M952 311L953 312L952 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M83.3333 313.667L83.6667 314.333L83.3333 313.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M953.667 313.333L954.333 313.667L953.667 313.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      stroke: "none"
    },
    d: "M83 315L84 316L83 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M84.6667 315.333L85.3333 315.667L84.6667 315.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M955 315L956 316L955 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M955 316L956 317L955 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M955 317L956 318L955 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M956 317L957 318L956 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cccccc",
      stroke: "none"
    },
    d: "M86 319L87 320L86 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8c8c",
      stroke: "none"
    },
    d: "M87 319L88 320L87 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M957.667 319.333L958.333 319.667L957.667 319.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4b4b4",
      stroke: "none"
    },
    d: "M959 319L960 320L959 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M87 320L88 321L87 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M959 320L960 321L959 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M89 321L90 322L89 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373",
      stroke: "none"
    },
    d: "M959 321L960 322L959 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M960 321L960 322L965 322L960 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbcbc",
      stroke: "none"
    },
    d: "M965 321L966 322L965 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#181818",
      stroke: "none"
    },
    d: "M965 322L966 323L965 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M965 323L966 324L965 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M966 323L967 324L966 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acacac",
      stroke: "none"
    },
    d: "M967 323L968 324L967 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M967 324L968 325L967 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6b6b6",
      stroke: "none"
    },
    d: "M91 325L91 329L92 329L91 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M967 325L968 326L967 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbcbc",
      stroke: "none"
    },
    d: "M968 325L969 326L968 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M965 327L966 328L965 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M966 327L966 328L969 328L966 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#181818",
      stroke: "none"
    },
    d: "M965 328L966 329L965 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M91 329L92 330L91 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M92 329L93 330L92 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M93 329L94 330L93 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M963.333 329.667L963.667 330.333L963.333 329.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M93 330L93 337L94 337L93 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M933 331L933 332L945 332L933 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M957 331L958 332L957 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M958 331L958 332L963 332L958 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M963 331L964 332L963 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252525",
      stroke: "none"
    },
    d: "M957 332L958 333L957 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040404",
      stroke: "none"
    },
    d: "M930 333L931 334L930 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada",
      stroke: "none"
    },
    d: "M931 333L932 334L931 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M953 333L953 334L957 334L953 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M930 334L931 335L930 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M929 335L930 336L929 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M930 335L931 336L930 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M90 337L90 338L93 338L90 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M93 337L94 338L93 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M929 337L930 338L929 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M930 337L931 338L930 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M930 338L931 339L930 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M930 339L931 340L930 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M931 339L932 340L931 339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M931 340L932 341L931 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M43 341L44 342L43 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M44 341L44 342L53 342L44 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M75 341L76 342L75 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M76 341L76 342L89 342L76 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c2c2c",
      stroke: "none"
    },
    d: "M89 341L90 342L89 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0b0b0",
      stroke: "none"
    },
    d: "M931 341L932 342L931 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M932 341L932 342L935 342L932 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M935 341L936 342L935 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M43 342L44 343L43 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M75 342L76 343L75 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M935 342L936 343L935 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M41 343L42 344L41 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M42 343L43 344L42 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M43 343L44 344L43 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M53.6667 343.333L54.3333 343.667L53.6667 343.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0b0b0",
      stroke: "none"
    },
    d: "M55 343L56 344L55 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M75 343L76 344L75 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M76.6667 343.333L77.3333 343.667L76.6667 343.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313131",
      stroke: "none"
    },
    d: "M933 343L934 344L933 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M934 343L935 344L934 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec",
      stroke: "none"
    },
    d: "M935 343L936 344L935 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M41 344L41 349L42 349L41 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M55 344L56 345L55 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d4d4d",
      stroke: "none"
    },
    d: "M933 344L934 345L933 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373",
      stroke: "none"
    },
    d: "M55 345L56 346L55 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M56 345L57 346L56 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2a2a2",
      stroke: "none"
    },
    d: "M79 345L79 349L80 349L79 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M57 347L57 348L61 348L57 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M61 347L62 348L61 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M61 348L62 349L61 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M45 349L46 350L45 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M61 349L62 350L61 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M62 349L63 350L62 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M63 349L64 350L63 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3d",
      stroke: "none"
    },
    d: "M81 349L82 350L81 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M933 349L934 350L933 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5",
      stroke: "none"
    },
    d: "M934 349L935 350L934 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M45 350L45 353L46 353L45 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878",
      stroke: "none"
    },
    d: "M63 350L64 351L63 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M934 350L935 351L934 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313131",
      stroke: "none"
    },
    d: "M63 351L64 352L63 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M64 351L65 352L64 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M65 351L66 352L65 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M934 351L935 352L934 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M935.667 351.333L936.333 351.667L935.667 351.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M65 352L66 353L65 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M47 353L47 357L48 357L47 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M65 353L66 354L65 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M83 353L83 359L84 359L83 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M937 353L938 354L937 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      stroke: "none"
    },
    d: "M938 353L939 354L938 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M939 353L940 354L939 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M939 354L940 355L939 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M67.6667 355.333L68.3333 355.667L67.6667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M69 355L70 356L69 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545454",
      stroke: "none"
    },
    d: "M939 355L940 356L939 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M940 355L940 356L947 356L940 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M947 355L948 356L947 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M69 356L70 357L69 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M947 356L948 357L947 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M45 357L46 358L45 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M46 357L47 358L46 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M47 357L48 358L47 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M69 357L70 358L69 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M70 357L71 358L70 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M71 357L72 358L71 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M949 357L949 358L953 358L949 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M45 358L45 373L46 373L45 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      stroke: "none"
    },
    d: "M71 358L72 359L71 358M73 359L74 360L73 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M74 359L75 360L74 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M75 359L76 360L75 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M82 359L83 360L82 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M83 359L84 360L83 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M953 359L953 360L961 360L953 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M75 360L76 361L75 360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M75 361L76 362L75 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M76 361L76 362L81 362L76 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252525",
      stroke: "none"
    },
    d: "M81 361L82 362L81 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M961 361L962 362L961 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M962 361L962 362L969 362L962 361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c7c7c",
      stroke: "none"
    },
    d: "M969.667 363.333L970.333 363.667L969.667 363.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282",
      stroke: "none"
    },
    d: "M971.667 367.333L972.333 367.667L971.667 367.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M45 373L46 374L45 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M46 373L47 374L46 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M47 373L48 374L47 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d",
      stroke: "none"
    },
    d: "M975 373L976 374L975 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M47 374L48 375L47 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M49 375L50 376L49 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      stroke: "none"
    },
    d: "M49 376L49 379L50 379L49 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M51.3333 379.667L51.6667 380.333L51.3333 379.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M979 379L979 380L985 380L979 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M985 379L986 380L985 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M985 380L985 383L986 383L985 380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M51 381L52 382L51 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5",
      stroke: "none"
    },
    d: "M52 381L53 382L52 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M53 381L54 382L53 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M55 383L56 384L55 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M56 383L57 384L56 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9d9d",
      stroke: "none"
    },
    d: "M986 383L987 384L986 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M57 385L58 386L57 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M951 385L951 386L967 386L951 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M967 385L968 386L967 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M969.667 385.333L970.333 385.667L969.667 385.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636363",
      stroke: "none"
    },
    d: "M971 385L972 386L971 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M985 385L986 386L985 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M986 385L987 386L986 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M57 386L58 387L57 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M949 386L950 387L949 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M971 386L972 387L971 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M985 386L986 387L985 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M57 387L58 388L57 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M58 387L59 388L58 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M947 387L948 388L947 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M948 387L949 388L948 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M971 387L972 388L971 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M972 387L972 388L982 388L972 387M983.667 387.333L984.333 387.667L983.667 387.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M985 387L986 388L985 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M947.333 388.667L947.667 389.333L947.333 388.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M59 389L60 390L59 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M61 390L62 391L61 390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M27 391L28 392L27 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaaaaa",
      stroke: "none"
    },
    d: "M28 391L28 392L37 392L28 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585858",
      stroke: "none"
    },
    d: "M61 391L62 392L61 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555",
      stroke: "none"
    },
    d: "M62 391L63 392L62 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M63 391L64 392L63 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M27 392L27 399L28 399L27 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "none"
    },
    d: "M63 392L64 393L63 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e2e",
      stroke: "none"
    },
    d: "M37.6667 393.333L38.3333 393.667L37.6667 393.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M39 393L40 394L39 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaeaea",
      stroke: "none"
    },
    d: "M63 393L64 394L63 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M64.6667 393.333L65.3333 393.667L64.6667 393.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M947 394L947 397L948 397L947 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M41.6667 395.333L42.3333 395.667L41.6667 395.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M43 395L44 396L43 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M43 396L44 397L43 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M43 397L44 398L43 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353535",
      stroke: "none"
    },
    d: "M44 397L45 398L44 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M66 397L67 398L66 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M67 397L68 398L67 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M947 397L948 398L947 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353535",
      stroke: "none"
    },
    d: "M948 397L949 398L948 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M47 398L48 399L47 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M67 398L68 399L67 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aeaeae",
      stroke: "none"
    },
    d: "M951 398L952 399L951 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M29 399L30 400L29 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M47 399L48 400L47 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M48 399L49 400L48 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aeaeae",
      stroke: "none"
    },
    d: "M67 399L68 400L67 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M68 399L69 400L68 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M69 399L70 400L69 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M953.667 399.333L954.333 399.667L953.667 399.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M955 399L956 400L955 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "none"
    },
    d: "M29 400L30 401L29 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M69 400L70 401L69 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M955 400L956 401L955 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M29 401L30 402L29 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M30 401L31 402L30 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M31 401L32 402L31 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M49.6667 401.333L50.3333 401.667L49.6667 401.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M69 401L70 402L69 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272727",
      stroke: "none"
    },
    d: "M955 401L956 402L955 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M956 401L956 402L959 402L956 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M31 402L31 414L32 414L31 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M51 402L52 403L51 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M51 403L52 404L51 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M52 403L53 404L52 403M961 403L961 404L965 404L961 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242",
      stroke: "none"
    },
    d: "M53.6667 405.333L54.3333 405.667L53.6667 405.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M55 405L56 406L55 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242",
      stroke: "none"
    },
    d: "M965.667 405.333L966.333 405.667L965.667 405.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M967 405L968 406L967 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M969 405L970 406L969 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242",
      stroke: "none"
    },
    d: "M970 405L971 406L970 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M57 407L57 408L61 408L57 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M61 407L62 408L61 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5",
      stroke: "none"
    },
    d: "M67 407L68 408L67 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M68 407L69 408L68 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M69 407L70 408L69 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M971 407L971 408L977 408L971 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M61 408L62 409L61 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M67 408L68 409L67 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M61 409L62 410L61 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M62 409L62 410L67 410L62 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292929",
      stroke: "none"
    },
    d: "M67 409L68 410L67 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M977.667 409.333L978.333 409.667L977.667 409.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M979 409L980 410L979 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M981 410L981 413L982 413L981 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f4f4f",
      stroke: "none"
    },
    d: "M981 413L982 414L981 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M982 413L983 414L982 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d2d2",
      stroke: "none"
    },
    d: "M983.667 415.333L984.333 415.667L983.667 415.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M985 415L986 416L985 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M985 416L985 422L986 422L985 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d",
      stroke: "none"
    },
    d: "M31 417L32 418L31 417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M32 417L33 418L32 417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M31 418L32 419L31 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M33 419L34 420L33 419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M33 420L33 423L34 423L33 420z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada",
      stroke: "none"
    },
    d: "M33 423L34 424L33 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M34 423L35 424L34 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M35 423L36 424L35 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M35 424L36 425L35 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M35 425L36 426L35 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M36 425L37 426L36 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686",
      stroke: "none"
    },
    d: "M37 425L38 426L37 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M37 426L38 427L37 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M37 427L38 428L37 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M38 427L39 428L38 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M39 427L40 428L39 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      stroke: "none"
    },
    d: "M987.667 427.333L988.333 427.667L987.667 427.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M989 427L990 428L989 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M39 428L40 429L39 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M989 428L990 429L989 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd",
      stroke: "none"
    },
    d: "M39 429L40 430L39 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959595",
      stroke: "none"
    },
    d: "M40 429L41 430L40 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858585",
      stroke: "none"
    },
    d: "M41 429L42 430L41 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636363",
      stroke: "none"
    },
    d: "M989 429L990 430L989 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      stroke: "none"
    },
    d: "M990 429L990 430L993 430L990 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M993 429L994 430L993 429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M41 430L42 431L41 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M993 430L993 435L994 435L993 430z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M43.3333 431.667L43.6667 432.333L43.3333 431.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M957 431L957 432L961 432L957 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e2e",
      stroke: "none"
    },
    d: "M961 431L962 432L961 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M963 431L963 432L971 432L963 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M971 431L972 432L971 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M971 432L972 433L971 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbcbc",
      stroke: "none"
    },
    d: "M43 433L44 434L43 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M44 433L45 434L44 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282",
      stroke: "none"
    },
    d: "M45 433L46 434L45 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M955 433L956 434L955 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M956 433L957 434L956 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M971 433L972 434L971 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M972 433L972 434L977 434L972 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M45 434L46 435L45 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M955 434L955 441L956 441L955 434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaeaea",
      stroke: "none"
    },
    d: "M45 435L46 436L45 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M46 435L47 436L46 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M47 435L48 436L47 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M47 436L48 437L47 436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M47 437L48 438L47 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "none"
    },
    d: "M48 437L49 438L48 437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M51.3333 439.667L51.6667 440.333L51.3333 439.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9d9d",
      stroke: "none"
    },
    d: "M19 441L20 442L19 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7e7e",
      stroke: "none"
    },
    d: "M20 441L20 442L23 442L20 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M23 441L24 442L23 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bababa",
      stroke: "none"
    },
    d: "M51 441L52 442L51 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M52 441L53 442L52 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M53 441L54 442L53 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M955 441L956 442L955 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7e7e",
      stroke: "none"
    },
    d: "M956 441L957 442L956 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M15 442L15 449L16 449L15 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M23.3333 442.667L23.6667 443.333L23.3333 442.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M53 442L54 443L53 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M54 443L55 444L54 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      stroke: "none"
    },
    d: "M55 443L56 444L55 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M55 444L57 446L55 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M959 444L960 445L959 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M29 445L29 446L33 446L29 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bababa",
      stroke: "none"
    },
    d: "M55 445L56 446L55 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      stroke: "none"
    },
    d: "M57 445L58 446L57 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545454",
      stroke: "none"
    },
    d: "M959 445L960 446L959 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M960 445L961 446L960 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M57.3333 446.667L57.6667 447.333L57.3333 446.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M961 446L962 447L961 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M961 447L962 448L961 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M962 447L963 448L962 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M59 448L59 456L60 456L59 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M967 448L968 449L967 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M15 449L16 450L15 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M16 449L17 450L16 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555",
      stroke: "none"
    },
    d: "M17 449L18 450L17 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M37.6667 449.333L38.3333 449.667L37.6667 449.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d4d4d4",
      stroke: "none"
    },
    d: "M39 449L40 450L39 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M967 449L968 450L967 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M968 449L969 450L968 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M17 450L18 451L17 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M17 451L18 452L17 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      stroke: "none"
    },
    d: "M18 451L18 452L21 452L18 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M21 452L22 453L21 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M43 452L44 453L43 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M21 453L22 454L21 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M22 453L23 454L22 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M23 453L24 454L23 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M43 453L44 454L43 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M44 453L45 454L44 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M47 453L48 454L47 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M48 453L49 454L48 453M975.667 453.333L976.333 453.667L975.667 453.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M23 454L23 471L24 471L23 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M45 454L47 456L45 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M47 454L48 455L47 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M45 455L46 456L45 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M47 455L48 456L47 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M53 456L54 457L53 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M57 456L58 457L57 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M981 456L982 457L981 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M53 457L54 458L53 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M54 457L54 458L57 458L54 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797",
      stroke: "none"
    },
    d: "M57 457L58 458L57 457M981 457L982 458L981 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M982 457L982 458L985 458L982 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M985 457L986 458L985 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M985.333 458.667L985.667 459.333L985.333 458.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373",
      stroke: "none"
    },
    d: "M987 460L988 461L987 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M987 461L988 462L987 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M988 461L989 462L988 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M989 461L990 462L989 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M989 462L989 468L990 468L989 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M23 471L24 472L23 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "none"
    },
    d: "M24 471L25 472L24 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8",
      stroke: "none"
    },
    d: "M25 472L26 473L25 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M25 473L26 474L25 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M26 473L28 475L26 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M27 473L28 474L27 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M991 473L992 474L991 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6c6c",
      stroke: "none"
    },
    d: "M991 474L992 475L991 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M27 475L28 476L27 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8",
      stroke: "none"
    },
    d: "M28 475L29 476L28 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a3a3",
      stroke: "none"
    },
    d: "M29 475L30 476L29 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171717",
      stroke: "none"
    },
    d: "M991 475L992 476L991 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373737",
      stroke: "none"
    },
    d: "M992 475L993 476L992 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M993 475L994 476L993 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "none"
    },
    d: "M29 476L30 477L29 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M993 476L994 477L993 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M29 477L30 478L29 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M30 477L30 478L33 478L30 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M33 477L34 478L33 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M965 477L965 478L969 478L965 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M993 477L994 478L993 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M994 477L995 478L994 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M33 478L34 479L33 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M33 479L34 480L33 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M34 479L35 480L34 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M35 479L36 480L35 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M961 479L961 480L965 480L961 479M969 479L969 480L975 480L969 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M975 479L976 480L975 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M995 479L996 480L995 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M35 480L36 481L35 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797979",
      stroke: "none"
    },
    d: "M975 480L976 481L975 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282",
      stroke: "none"
    },
    d: "M35 481L36 482L35 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M36 481L37 482L36 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M37 481L38 482L37 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828",
      stroke: "none"
    },
    d: "M959 481L960 482L959 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M960 481L961 482L960 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M975 481L976 482L975 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M976 481L976 482L979 482L976 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M979 481L980 482L979 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M37 482L38 483L37 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M959 482L959 485L960 485L959 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M979 482L980 483L979 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f6f6",
      stroke: "none"
    },
    d: "M37 483L38 484L37 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M38 483L39 484L38 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M39 483L40 484L39 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M979 483L980 484L979 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M980 483L980 484L987 484L980 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M987 483L988 484L987 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M39 484L40 485L39 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M989 484L990 485L989 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282",
      stroke: "none"
    },
    d: "M39 485L40 486L39 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M40 485L41 486L40 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M41 485L42 486L41 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6b6b6",
      stroke: "none"
    },
    d: "M959 485L960 486L959 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M989 485L990 486L989 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M990 485L990 486L999 486L990 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M41 486L42 487L41 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M41 487L42 488L41 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4b4b4",
      stroke: "none"
    },
    d: "M42 487L43 488L42 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M43 487L44 488L43 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd",
      stroke: "none"
    },
    d: "M959 487L960 488L959 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M43 488L44 489L43 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M43 489L44 490L43 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M44 489L44 490L47 490L44 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M47 489L48 490L47 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cdcdcd",
      stroke: "none"
    },
    d: "M961.667 489.333L962.333 489.667L961.667 489.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M47 490L48 491L47 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M47 491L48 492L47 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M48 491L49 492L48 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M963 491L964 492L963 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      stroke: "none"
    },
    d: "M49 492L50 493L49 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M17 493L18 494L17 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d4d4d4",
      stroke: "none"
    },
    d: "M18 493L19 494L18 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M19 493L20 494L19 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M49 493L50 494L49 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b2b2b",
      stroke: "none"
    },
    d: "M50 493L51 494L50 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#131313",
      stroke: "none"
    },
    d: "M51 493L52 494L51 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d4d4d4",
      stroke: "none"
    },
    d: "M965.667 493.333L966.333 493.667L965.667 493.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M967 493L968 494L967 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M17.3333 494.667L17.6667 495.333L17.3333 494.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M19.3333 494.667L19.6667 495.333L19.3333 494.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M51 494L52 495L51 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M967.333 494.667L967.667 495.333L967.333 494.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "none"
    },
    d: "M51 495L52 496L51 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7a7a7",
      stroke: "none"
    },
    d: "M52 495L53 496L52 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4b4b4",
      stroke: "none"
    },
    d: "M13 496L13 503L14 503L13 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M23 496L24 497L23 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M53 496L54 497L53 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M23 497L24 498L23 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb",
      stroke: "none"
    },
    d: "M24 497L24 498L29 498L24 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M53 497L54 498L53 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M54 497L55 498L54 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111111",
      stroke: "none"
    },
    d: "M55 497L56 498L55 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb",
      stroke: "none"
    },
    d: "M969 497L969 498L975 498L969 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M55 498L55 501L56 501L55 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M29 499L30 500L29 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a5a5",
      stroke: "none"
    },
    d: "M35 500L36 501L35 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M35 501L36 502L35 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M36 501L36 502L39 502L36 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M39 501L40 502L39 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M53 501L54 502L53 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M54 501L55 502L54 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M55 501L56 502L55 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M977.667 501.333L978.333 501.667L977.667 501.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M39.3333 502.667L39.6667 503.333L39.3333 502.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M53 502L54 503L53 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e1e1e1",
      stroke: "none"
    },
    d: "M13 503L14 504L13 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M14 503L14 504L17 504L14 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M53 503L54 504L53 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b2b2",
      stroke: "none"
    },
    d: "M979 503L980 504L979 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M17 504L18 505L17 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M51 504L52 505L51 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M981 504L982 505L981 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M17 505L18 506L17 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171717",
      stroke: "none"
    },
    d: "M18 505L19 506L18 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M19 505L20 506L19 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M45 505L45 506L51 506L45 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M51 505L52 506L51 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5",
      stroke: "none"
    },
    d: "M981 505L982 506L981 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M982 505L982 506L985 506L982 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M985 505L986 506L985 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M19 506L19 513L20 513L19 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M985.333 506.667L985.667 507.333L985.333 506.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M989 508L989 512L990 512L989 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M19 513L20 514L19 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M20 513L21 514L20 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M21 513L22 514L21 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M989 513L990 514L989 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M21 514L21 519L22 519L21 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M989 514L990 515L989 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M989 515L990 516L989 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M21 519L22 520L21 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M22 519L23 520L22 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232323",
      stroke: "none"
    },
    d: "M23 519L24 520L23 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M23 520L23 525L24 525L23 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M23 525L24 526L23 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M24 525L25 526L24 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M27 526L28 527L27 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M971 526L973 528L971 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6c6c",
      stroke: "none"
    },
    d: "M991 526L992 527L991 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M27 527L28 528L27 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M28 527L29 528L28 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M29 527L30 528L29 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M959 527L960 528L959 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M960 527L961 528L960 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M971 527L972 528L971 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M991 527L992 528L991 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d",
      stroke: "none"
    },
    d: "M992 527L993 528L992 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M993 527L994 528L993 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "none"
    },
    d: "M29.3333 528.667L29.6667 529.333L29.3333 528.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      stroke: "none"
    },
    d: "M995.333 528.667L995.667 529.333L995.333 528.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M975 529L976 530L975 529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M33 530L34 531L33 530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M997 530L997 535L998 535L997 530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M33 531L34 532L33 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6c6c",
      stroke: "none"
    },
    d: "M34 531L35 532L34 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M35 531L36 532L35 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6c6c",
      stroke: "none"
    },
    d: "M977 531L977 532L981 532L977 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M981 531L982 532L981 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M35 532L36 533L35 532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M35 533L36 534L35 533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M36 533L37 534L36 533M982 533L982 534L985 534L982 533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M985 533L986 534L985 533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M39 534L40 535L39 534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M39 535L40 536L39 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      stroke: "none"
    },
    d: "M40 535L41 536L40 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M41 535L42 536L41 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada",
      stroke: "none"
    },
    d: "M959 535L960 536L959 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      stroke: "none"
    },
    d: "M991 535L991 536L997 536L991 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eeeeee",
      stroke: "none"
    },
    d: "M997 535L998 536L997 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M41 536L42 537L41 536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M41 537L42 538L41 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e1e1e1",
      stroke: "none"
    },
    d: "M42 537L43 538L42 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M43 537L44 538L43 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M45 538L46 539L45 538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M45 539L46 540L45 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M46 539L47 540L46 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828",
      stroke: "none"
    },
    d: "M47 539L48 540L47 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada",
      stroke: "none"
    },
    d: "M963 539L964 540L963 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M51 542L52 543L51 542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a3a3",
      stroke: "none"
    },
    d: "M51 543L52 544L51 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M52 543L53 544L52 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada",
      stroke: "none"
    },
    d: "M967 543L968 544L967 543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M53.3333 544.667L53.6667 545.333L53.3333 544.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M55 546L55 550L56 550L55 546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb",
      stroke: "none"
    },
    d: "M971 547L972 548L971 547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M15.3333 548.667L15.6667 549.333L15.3333 548.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M11 549L12 550L11 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M12 549L13 550L12 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M13 549L14 550L13 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b3b3b",
      stroke: "none"
    },
    d: "M973 549L974 550L973 549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M11 550L11 554L12 554L11 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M53 550L53 554L54 554L53 550z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M37 551L38 552L37 551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M43.3333 552.667L43.6667 553.333L43.3333 552.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4b4b4",
      stroke: "none"
    },
    d: "M13 554L14 555L13 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f0f0f",
      stroke: "none"
    },
    d: "M49 554L50 555L49 554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M981.333 554.667L981.667 555.333L981.333 554.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8",
      stroke: "none"
    },
    d: "M13 555L14 556L13 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M14 555L14 556L17 556L14 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M17 555L18 556L17 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M49 555L50 556L49 555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M50 555L50 556L53 556L50 555M17.3333 556.667L17.6667 557.333L17.3333 556.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M985 558L985 568L986 568L985 558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e2e",
      stroke: "none"
    },
    d: "M21 559L22 560L21 559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M21 560L21 564L22 564L21 560z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M21 564L22 565L21 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M22 564L23 565L22 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242",
      stroke: "none"
    },
    d: "M23 564L24 565L23 564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M23 565L23 569L24 569L23 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111111",
      stroke: "none"
    },
    d: "M985 568L986 569L985 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M23 569L24 570L23 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M24 569L25 570L24 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545454",
      stroke: "none"
    },
    d: "M986 569L987 570L986 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8",
      stroke: "none"
    },
    d: "M25 570L25 574L26 574L25 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M955 571L956 572L955 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292929",
      stroke: "none"
    },
    d: "M956 571L956 572L961 572L956 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M955 572L956 573L955 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcbcb",
      stroke: "none"
    },
    d: "M961 572L962 573L961 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e1e1e1",
      stroke: "none"
    },
    d: "M955 573L956 574L955 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M961 573L962 574L961 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a5a5",
      stroke: "none"
    },
    d: "M962 573L963 574L962 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M963 573L964 574L963 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M27.3333 574.667L27.6667 575.333L27.3333 574.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M965 574L966 575L965 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaeaea",
      stroke: "none"
    },
    d: "M965 575L966 576L965 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M966 575L967 576L966 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M967 575L968 576L967 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M27 576L28 577L27 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M28 576L29 577L28 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M967 576L968 577L967 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M968 576L969 577L968 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M29 577L30 578L29 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M33 578L34 579L33 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M971 578L972 579L971 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M989 578L990 579L989 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada",
      stroke: "none"
    },
    d: "M33 579L34 580L33 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M34 579L35 580L34 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M35 579L36 580L35 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M971 579L972 580L971 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M972 579L972 580L975 580L972 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M975 579L976 580L975 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M989 579L990 580L989 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M990 579L991 580L990 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M35 580L36 581L35 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797979",
      stroke: "none"
    },
    d: "M975 580L976 581L975 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbcbc",
      stroke: "none"
    },
    d: "M35 581L36 582L35 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797",
      stroke: "none"
    },
    d: "M36 581L36 582L39 582L36 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393939",
      stroke: "none"
    },
    d: "M39 581L40 582L39 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8",
      stroke: "none"
    },
    d: "M975 581L976 582L975 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797",
      stroke: "none"
    },
    d: "M976 581L977 582L976 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M41 582L42 583L41 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M993 582L993 585L994 585L993 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5",
      stroke: "none"
    },
    d: "M41 583L42 584L41 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M42 583L43 584L42 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M43 583L44 584L43 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eeeeee",
      stroke: "none"
    },
    d: "M953 583L954 584L953 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M977 583L977 584L981 584L977 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M43 584L44 585L43 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M953 584L954 585L953 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M954 584L955 585L954 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M981 584L982 585L981 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd",
      stroke: "none"
    },
    d: "M43 585L44 586L43 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M44 585L44 586L47 586L44 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    d: "M47 585L48 586L47 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M981 585L982 586L981 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M982 585L983 586L982 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M983 585L984 586L983 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M991.667 585.333L992.333 585.667L991.667 585.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M993 585L994 586L993 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      stroke: "none"
    },
    d: "M49 586L50 587L49 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M49 587L50 588L49 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M50 587L51 588L50 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M51 587L52 588L51 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M957.667 587.333L958.333 587.667L957.667 587.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M51 588L52 589L51 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcbcb",
      stroke: "none"
    },
    d: "M52 588L53 589L52 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4b4b4",
      stroke: "none"
    },
    d: "M959 588L960 589L959 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a8a8a",
      stroke: "none"
    },
    d: "M53.6667 589.333L54.3333 589.667L53.6667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343",
      stroke: "none"
    },
    d: "M55 589L56 590L55 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M959 589L960 590L959 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M57.6667 591.333L58.3333 591.667L57.6667 591.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040404",
      stroke: "none"
    },
    d: "M59 591L60 592L59 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M961.667 591.333L962.333 591.667L961.667 591.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M59.3333 592.667L59.6667 593.333L59.3333 592.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M963 592L964 593L963 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M963 593L964 594L963 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M62.6667 595.333L63.3333 595.667L62.6667 595.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M965 595L966 596L965 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "none"
    },
    d: "M63.3333 596.667L63.6667 597.333L63.3333 596.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M965 596L966 597L965 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M966 596L967 597L966 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M967 597L968 598L967 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M31.3333 598.667L31.6667 599.333L31.3333 598.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M19 600L19 604L20 604L19 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c2c2c",
      stroke: "none"
    },
    d: "M39 600L40 601L39 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M40 600L41 601L40 600M969.667 600.333L970.333 600.667L969.667 600.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M21 604L21 608L22 608L21 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686",
      stroke: "none"
    },
    d: "M975.333 606.667L975.667 607.333L975.333 606.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8",
      stroke: "none"
    },
    d: "M25 608L26 609L25 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dfdfdf",
      stroke: "none"
    },
    d: "M25 609L26 610L25 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M26 609L27 610L26 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M27 609L28 610L27 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373737",
      stroke: "none"
    },
    d: "M975 609L976 610L975 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M976 609L977 610L976 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M27.3333 610.667L27.6667 611.333L27.3333 610.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "none"
    },
    d: "M29 612L29 616L30 616L29 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M975 612L976 613L975 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M976 612L977 613L976 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M31 616L31 620L32 620L31 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686",
      stroke: "none"
    },
    d: "M975 616L976 617L975 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M945 617L945 618L949 618L945 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M975 617L976 618L975 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a3a3",
      stroke: "none"
    },
    d: "M976 617L977 618L976 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cccccc",
      stroke: "none"
    },
    d: "M949.333 618.667L949.667 619.333L949.333 618.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M953 620L954 621L953 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M954 620L955 621L954 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M955.667 621.333L956.333 621.667L955.667 621.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M35.3333 624.667L35.6667 625.333L35.3333 624.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M959 624L960 625L959 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M959 625L960 626L959 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f4f4f",
      stroke: "none"
    },
    d: "M960 625L961 626L960 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M39.3333 626.667L39.6667 627.333L39.3333 626.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M943.333 628.667L943.667 629.333L943.333 628.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      stroke: "none"
    },
    d: "M963 628L964 629L963 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404040",
      stroke: "none"
    },
    d: "M41 629L42 630L41 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M963 629L964 630L963 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M964 629L965 630L964 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M965.333 630.667L965.667 631.333L965.333 630.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M55.3333 632.667L55.6667 633.333L55.3333 632.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M971 632L972 633L971 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959595",
      stroke: "none"
    },
    d: "M971 633L972 634L971 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M972 633L972 634L979 634L972 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M59.3333 634.667L59.6667 635.333L59.3333 634.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M947.333 634.667L947.667 635.333L947.333 634.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M65.3333 636.667L65.6667 637.333L65.3333 636.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M65.6667 638.333L66.3333 638.667L65.6667 638.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M67 638L68 639L67 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M949.667 638.333L950.333 638.667L949.667 638.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M951 638L952 639L951 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M67 639L68 640L67 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aeaeae",
      stroke: "none"
    },
    d: "M951 639L951 642L952 642L951 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959595",
      stroke: "none"
    },
    d: "M71 640L71 649L72 649L71 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M951 642L952 643L951 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M952 642L953 643L952 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M955.333 644.667L955.667 645.333L955.333 644.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M955 646L956 647L955 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M956 646L957 647L956 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M37 648L38 649L37 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M41 648L42 649L41 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M43 648L44 649L43 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M47 648L48 649L47 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M51 648L52 649L51 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M33 649L34 650L33 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M34 649L34 650L37 650L34 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M37 649L38 650L37 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#181818",
      stroke: "none"
    },
    d: "M41 649L42 650L41 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M42 649L43 650L42 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M43 649L44 650L43 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M47 649L48 650L47 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M48 649L48 650L51 650L48 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M51 649L52 650L51 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M53 649L53 650L71 650L53 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M71 649L72 650L71 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M33 650L34 651L33 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M959 650L960 651L959 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M959 651L960 652L959 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4b4b4",
      stroke: "none"
    },
    d: "M29 654L30 655L29 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M961.667 654.333L962.333 654.667L961.667 654.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M963 654L964 655L963 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a9a9a",
      stroke: "none"
    },
    d: "M963 655L964 656L963 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M31.3333 656.667L31.6667 657.333L31.3333 656.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M31 658L32 659L31 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M32 658L32 659L37 659L32 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M961 658L962 659L961 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M962 658L963 659L962 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M961 659L962 660L961 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M43.3333 664.667L43.6667 665.333L43.3333 664.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M931 664L931 672L932 672L931 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M937 664L938 665L937 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbcbc",
      stroke: "none"
    },
    d: "M937 665L938 666L937 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M938 665L939 666L938 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M939 665L940 666L939 665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dfdfdf",
      stroke: "none"
    },
    d: "M43 666L44 667L43 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M44 666L45 667L44 666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3d",
      stroke: "none"
    },
    d: "M939.333 666.667L939.667 667.333L939.333 666.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M941 668L942 669L941 668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M45 669L46 670L45 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M941 669L942 670L941 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M942 669L943 670L942 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M943 669L944 670L943 669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M45 670L46 671L45 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M46 670L47 671L46 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545454",
      stroke: "none"
    },
    d: "M47 670L48 671L47 670z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M943.333 670.667L943.667 671.333L943.333 670.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M47 671L48 672L47 671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M93 672L93 676L94 676L93 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777777",
      stroke: "none"
    },
    d: "M937 674L938 675L937 674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M937 675L938 676L937 675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M69.3333 676.667L69.6667 677.333L69.3333 676.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dfdfdf",
      stroke: "none"
    },
    d: "M77.3333 676.667L77.6667 677.333L77.3333 676.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M85.3333 676.667L85.6667 677.333L85.3333 676.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M939.333 676.667L939.667 677.333L939.333 676.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M57 678L58 679L57 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M939 678L940 679L939 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M940 678L941 679L940 678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M55.3333 680.667L55.6667 681.333L55.3333 680.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M51 682L51 686L52 686L51 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M941.667 682.333L942.333 682.667L941.667 682.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M943 682L944 683L943 682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M943 683L944 684L943 683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M55 688L55 692L56 692L55 688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f4f4f",
      stroke: "none"
    },
    d: "M59 690L60 691L59 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M60 690L61 691L60 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M61 690L62 691L61 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M947 690L947 700L948 700L947 690z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7e7e",
      stroke: "none"
    },
    d: "M59 691L60 692L59 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M61 691L62 692L61 691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M65 692L65 696L66 696L65 692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M67.3333 696.667L67.6667 697.333L67.3333 696.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M67 698L68 699L67 698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#949494",
      stroke: "none"
    },
    d: "M68 698L69 699L68 698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M69 698L70 699L69 698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M69 699L70 700L69 699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959595",
      stroke: "none"
    },
    d: "M71 700L71 704L72 704L71 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M919.333 700.667L919.667 701.333L919.333 700.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585858",
      stroke: "none"
    },
    d: "M921 702L922 703L921 702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M945 702L946 703L945 702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d",
      stroke: "none"
    },
    d: "M946 702L947 703L946 702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      stroke: "none"
    },
    d: "M921 703L922 704L921 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M945 703L946 704L945 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M73.3333 704.667L73.6667 705.333L73.3333 704.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M923.333 704.667L923.667 705.333L923.333 704.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "none"
    },
    d: "M75 706L75 707L79 707L75 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M79 706L80 707L79 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585858",
      stroke: "none"
    },
    d: "M925 706L926 707L925 706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2a2a2",
      stroke: "none"
    },
    d: "M79 707L80 708L79 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a5a5",
      stroke: "none"
    },
    d: "M925 707L926 708L925 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M93.3333 708.667L93.6667 709.333L93.3333 708.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      stroke: "none"
    },
    d: "M926.333 708.667L926.667 709.333L926.333 708.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M95 710L96 711L95 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      stroke: "none"
    },
    d: "M96 710L96 711L105 711L96 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272727",
      stroke: "none"
    },
    d: "M105 710L106 711L105 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373737",
      stroke: "none"
    },
    d: "M913 710L914 711L913 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M914 710L915 711L914 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M915 710L916 711L915 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292929",
      stroke: "none"
    },
    d: "M927.333 710.667L927.667 711.333L927.333 710.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M105 711L106 712L105 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaeaea",
      stroke: "none"
    },
    d: "M915 711L915 714L916 714L915 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M105 712L106 713L105 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M106 712L106 713L113 713L106 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M113 712L114 713L113 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M927.667 712.333L928.333 712.667L927.667 712.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M945.667 712.333L946.333 712.667L945.667 712.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6b6b6",
      stroke: "none"
    },
    d: "M947 712L948 713L947 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M113 713L113 716L114 716L113 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M947 713L948 714L947 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M929 714L930 715L929 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M930 714L931 715L930 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M947 714L948 715L947 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858585",
      stroke: "none"
    },
    d: "M948 714L949 715L948 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f1f1f1",
      stroke: "none"
    },
    d: "M930 715L931 716L930 715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M931 715L932 716L931 715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M113 716L114 717L113 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f6f6",
      stroke: "none"
    },
    d: "M114 716L115 717L114 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M115 716L116 717L115 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M917.667 716.333L918.333 716.667L917.667 716.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M919 716L920 717L919 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M931 716L932 717L931 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f6f6",
      stroke: "none"
    },
    d: "M932 716L933 717L932 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M115 717L115 720L116 720L115 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M919 717L919 722L920 722L919 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M933 718L934 719L933 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M934 718L935 719L934 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M947 718L947 722L948 722L947 718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M934 719L935 720L934 719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M935 719L936 720L935 719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada",
      stroke: "none"
    },
    d: "M111 720L112 721L111 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M112 720L112 721L115 721L112 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M115 720L116 721L115 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M935 720L936 721L935 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M936 720L937 721L936 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M111 721L112 722L111 721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M103.333 722.667L103.667 723.333L103.333 722.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbcbc",
      stroke: "none"
    },
    d: "M921 722L922 723L921 722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3d",
      stroke: "none"
    },
    d: "M939.333 722.667L939.667 723.333L939.333 722.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M921 723L921 726L922 726L921 723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M85 724L86 725L85 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M86 724L86 725L103 725L86 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111111",
      stroke: "none"
    },
    d: "M103 724L104 725L103 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eeeeee",
      stroke: "none"
    },
    d: "M939 724L940 725L939 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M940 724L941 725L940 724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M85 725L86 726L85 725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2a2a2",
      stroke: "none"
    },
    d: "M79 726L80 727L79 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M923 726L923 730L924 730L923 726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M79 727L80 728L79 727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393939",
      stroke: "none"
    },
    d: "M77 728L78 729L77 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M78 728L79 729L78 728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M77 729L78 730L77 729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M75 730L75 734L76 734L75 730z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M925 730L925 734L926 734L925 730z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M77.3333 734.667L77.6667 735.333L77.3333 734.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M927 734L927 740L928 740L927 734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dadada",
      stroke: "none"
    },
    d: "M77 736L78 737L77 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M78 736L79 737L78 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888",
      stroke: "none"
    },
    d: "M79 736L80 737L79 736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2a2a2",
      stroke: "none"
    },
    d: "M79 737L80 738L79 737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M85.3333 738.667L85.6667 739.333L85.3333 738.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M85 740L86 741L85 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M86 740L87 741L86 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M87 740L88 741L87 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M925 740L926 741L925 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M926 740L927 741L926 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M927 740L928 741L927 740z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M87 741L88 742L87 741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M925 741L925 746L926 746L925 741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      stroke: "none"
    },
    d: "M89.3333 742.667L89.6667 743.333L89.3333 742.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M895.667 742.333L896.333 742.667L895.667 742.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M89 744L90 745L89 744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M90 744L91 745L90 744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M91 744L92 745L91 744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M897.667 744.333L898.333 744.667L897.667 744.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6b6b6",
      stroke: "none"
    },
    d: "M91 745L92 746L91 745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M93.3333 746.667L93.6667 747.333L93.3333 746.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M889.333 746.667L889.667 747.333L889.333 746.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M923 746L923 752L924 752L923 746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfcfcf",
      stroke: "none"
    },
    d: "M93 748L94 749L93 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M94 748L95 749L94 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M95 748L96 749L95 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M889 748L890 749L889 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    d: "M890 748L891 749L890 748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M899.667 748.333L900.333 748.667L899.667 748.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd",
      stroke: "none"
    },
    d: "M95 749L96 750L95 749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M97.3333 750.667L97.6667 751.333L97.3333 750.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M902 750L903 751L902 750z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M903 751L903 754L904 754L903 751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cccccc",
      stroke: "none"
    },
    d: "M97 752L98 753L97 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bababa",
      stroke: "none"
    },
    d: "M98 752L98 753L115 753L98 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2a2a2",
      stroke: "none"
    },
    d: "M115 752L116 753L115 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545",
      stroke: "none"
    },
    d: "M891.667 752.333L892.333 752.667L891.667 752.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M921 752L922 753L921 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bababa",
      stroke: "none"
    },
    d: "M922 752L923 753L922 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f6f6",
      stroke: "none"
    },
    d: "M923 752L924 753L923 752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M115 753L116 754L115 753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M921 753L922 754L921 753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M135 754L136 755L135 754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M893 754L893 758L894 758L893 754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M923 754L923 764L924 764L923 754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3b3b3",
      stroke: "none"
    },
    d: "M136 756L136 757L139 757L136 756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M139 756L140 757L139 756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M139 757L139 762L140 762L139 757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M906 758L907 759L906 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M907 758L908 759L907 758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M907 759L908 760L907 759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0b0b0",
      stroke: "none"
    },
    d: "M907 760L908 761L907 760z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M908 760L909 761L908 760z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      stroke: "none"
    },
    d: "M909 762L910 763L909 762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M910 762L911 763L910 762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M911 762L912 763L911 762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M911 763L912 764L911 763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M131 764L132 765L131 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959",
      stroke: "none"
    },
    d: "M132 764L132 765L135 765L132 764M895.667 764.333L896.333 764.667L895.667 764.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b2b2",
      stroke: "none"
    },
    d: "M897 764L898 765L897 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M911 764L912 765L911 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M912 764L913 765L912 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M921 764L922 765L921 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M922 764L923 765L922 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M923 764L924 765L923 764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M131 765L132 766L131 765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888",
      stroke: "none"
    },
    d: "M897 765L897 770L898 770L897 765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M921 765L922 766L921 765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M121.333 766.667L121.667 767.333L121.333 766.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M913 766L914 767L913 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M914 766L915 767L914 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M915 766L916 767L915 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f0f0f",
      stroke: "none"
    },
    d: "M917 766L918 767L917 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M918 766L919 767L918 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M919 766L920 767L919 766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M915 767L916 768L915 767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M917 767L918 768L917 767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M113 768L114 769L113 768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M114 768L114 769L121 769L114 768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272727",
      stroke: "none"
    },
    d: "M121 768L122 769L121 768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a7a7a7",
      stroke: "none"
    },
    d: "M915 768L916 769L915 768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M916 768L917 769L916 768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M113 769L114 770L113 769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M107.333 770.667L107.667 771.333L107.333 770.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M103.333 772.667L103.667 773.333L103.333 772.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M101.333 774.667L101.667 775.333L101.333 774.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M99 776L100 777L99 776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M100 776L101 777L100 776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M101 776L102 777L101 776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M901 776L902 777L901 776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M99 777L99 780L100 780L99 777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M901 777L901 780L902 780L901 777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M99 780L100 781L99 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M100 780L101 781L100 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272727",
      stroke: "none"
    },
    d: "M101 780L102 781L101 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M865 780L866 781L865 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M866 780L866 781L869 781L866 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c6c6",
      stroke: "none"
    },
    d: "M901 780L902 781L901 780z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M101 781L102 782L101 781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M865 781L866 782L865 781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M103.333 782.667L103.667 783.333L103.333 782.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaaaaa",
      stroke: "none"
    },
    d: "M109.333 782.667L109.667 783.333L109.333 782.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M113.333 782.667L113.667 783.333L113.333 782.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      stroke: "none"
    },
    d: "M103 784L104 785L103 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858585",
      stroke: "none"
    },
    d: "M104 784L104 785L109 785L104 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M109 784L110 785L109 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M113 784L114 785L113 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858585",
      stroke: "none"
    },
    d: "M114 784L115 785L114 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M115 784L116 785L115 784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858585",
      stroke: "none"
    },
    d: "M871.667 784.333L872.333 784.667L871.667 784.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M115 785L116 786L115 785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M117.333 786.667L117.667 787.333L117.333 786.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888",
      stroke: "none"
    },
    d: "M897 786L897 790L898 790L897 786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0b0b0",
      stroke: "none"
    },
    d: "M117 788L118 789L117 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M118 788L119 789L118 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M119 788L120 789L119 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dfdfdf",
      stroke: "none"
    },
    d: "M865 788L866 789L865 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M873 788L874 789L873 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M874 788L875 789L874 788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5",
      stroke: "none"
    },
    d: "M119 789L120 790L119 789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M865 789L865 796L866 796L865 789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M120 790L121 791L120 790z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M121 790L122 791L121 790z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M895.667 790.333L896.333 790.667L895.667 790.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfdfd",
      stroke: "none"
    },
    d: "M897 790L898 791L897 790z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M121 791L122 792L121 791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M121 792L122 793L121 792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878",
      stroke: "none"
    },
    d: "M122 792L123 793L122 792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M123 792L124 793L123 792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878",
      stroke: "none"
    },
    d: "M875.667 792.333L876.333 792.667L875.667 792.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      stroke: "none"
    },
    d: "M123 793L124 794L123 793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M123 794L124 795L123 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M124 794L124 795L127 795L124 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M127 794L128 795L127 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M129 794L130 795L129 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M130 794L130 795L133 795L130 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777777",
      stroke: "none"
    },
    d: "M133 794L134 795L133 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M136 794L136 795L167 795L136 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M167 794L168 795L167 794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M127 795L128 796L127 795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M129 795L130 796L129 795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M133 795L134 796L133 795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M167 795L167 802L168 802L167 795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M127 796L128 797L127 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M128 796L129 797L128 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M129 796L130 797L129 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M133 796L134 797L133 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M134 796L135 797L134 796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M877.667 798.333L878.333 798.667L877.667 798.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M895.667 798.333L896.333 798.667L895.667 798.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M897 798L898 799L897 798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888",
      stroke: "none"
    },
    d: "M897 799L897 804L898 804L897 799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6b6b",
      stroke: "none"
    },
    d: "M879.667 800.333L880.333 800.667L879.667 800.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M165 802L166 803L165 802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#181818",
      stroke: "none"
    },
    d: "M166 802L167 803L166 802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M167 802L168 803L167 802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M165 803L166 804L165 803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M161 804L162 805L161 804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M869 804L870 805L869 804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M881 804L882 805L881 804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M882 804L883 805L882 804M895.667 804.333L896.333 804.667L895.667 804.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M161 805L162 806L161 805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M869 805L869 812L870 812L869 805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M156 806L156 807L161 807L156 806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M161 806L162 807L161 806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M883.667 806.333L884.333 806.667L883.667 806.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7e7e",
      stroke: "none"
    },
    d: "M893 806L894 807L893 806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M894 806L895 807L894 806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M893 807L894 808L893 807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9",
      stroke: "none"
    },
    d: "M149 808L150 809L149 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5e5e5e",
      stroke: "none"
    },
    d: "M885 808L885 809L893 809L885 808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797",
      stroke: "none"
    },
    d: "M149 809L150 810L149 809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M144 810L144 811L149 811L144 810z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M149 810L150 811L149 810z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M139 812L140 813L139 812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M139 813L140 814L139 813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2c2c2c",
      stroke: "none"
    },
    d: "M136 814L136 815L139 815L136 814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M139 814L140 815L139 814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M133 816L133 822L134 822L133 816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M833 816L834 817L833 816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M834 816L834 817L839 817L834 816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M833 817L833 830L834 830L833 817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cccccc",
      stroke: "none"
    },
    d: "M839 818L840 819L839 818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acacac",
      stroke: "none"
    },
    d: "M840 818L841 819L840 818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M840 819L840 822L841 822L840 819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353535",
      stroke: "none"
    },
    d: "M869 820L870 821L869 820z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M870 820L871 821L870 820z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M869 821L869 824L870 824L869 821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e1e1e1",
      stroke: "none"
    },
    d: "M133 822L134 823L133 822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M134 822L135 823L134 822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f6f6",
      stroke: "none"
    },
    d: "M840 822L841 823L840 822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M841.667 822.333L842.333 822.667L841.667 822.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343",
      stroke: "none"
    },
    d: "M136 824L137 825L136 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M137 824L138 825L137 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343",
      stroke: "none"
    },
    d: "M140 824L140 825L145 825L140 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M145 824L146 825L145 824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343",
      stroke: "none"
    },
    d: "M867.667 824.333L868.333 824.667L867.667 824.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383",
      stroke: "none"
    },
    d: "M137 825L138 826L137 825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M145 825L146 826L145 825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M137 826L138 827L137 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M138.667 826.333L139.333 826.667L138.667 826.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M145 826L146 827L145 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M146.667 826.333L147.333 826.667L146.667 826.333M843 826L844 827L843 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M844 826L845 827L844 826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M844 827L844 834L845 834L844 827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M148 828L148 829L151 829L148 828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M151 828L152 829L151 828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M865 828L866 829L865 828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M866 828L867 829L866 828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M151 829L152 830L151 829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M865 829L866 830L865 829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M151 830L152 831L151 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M152 830L153 831L152 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M153 830L154 831L153 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M184 830L184 831L199 831L184 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d4d4d",
      stroke: "none"
    },
    d: "M199 830L200 831L199 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343",
      stroke: "none"
    },
    d: "M833 830L834 831L833 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M834 830L835 831L834 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M863.667 830.333L864.333 830.667L863.667 830.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M865 830L866 831L865 830z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9d9d",
      stroke: "none"
    },
    d: "M153 831L154 832L153 831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6b6b",
      stroke: "none"
    },
    d: "M199 831L199 834L200 834L199 831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b2b2",
      stroke: "none"
    },
    d: "M153 832L154 833L153 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M154 832L154 833L157 833L154 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232323",
      stroke: "none"
    },
    d: "M157 832L158 833L157 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M172 832L172 833L183 833L172 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M183 832L184 833L183 832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M157 833L158 834L157 833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M157 834L158 835L157 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M158 834L158 835L172 835L158 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d2d2",
      stroke: "none"
    },
    d: "M199 834L200 835L199 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M200 834L201 835L200 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a5a5",
      stroke: "none"
    },
    d: "M201 834L202 835L201 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M844 834L845 835L844 834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M845.667 834.333L846.333 834.667L845.667 834.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M201 835L201 838L202 838L201 835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M197 838L198 839L197 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545454",
      stroke: "none"
    },
    d: "M198 838L198 839L201 839L198 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M201 838L202 839L201 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ababab",
      stroke: "none"
    },
    d: "M847 838L848 839L847 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M848 838L849 839L848 838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M197 839L198 840L197 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M848 839L848 842L849 842L848 839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M193.333 840.667L193.667 841.333L193.333 840.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M189 842L190 843L189 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M190 842L190 843L193 843L190 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M193 842L194 843L193 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M848 842L849 843L848 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M849.667 842.333L850.333 842.667L849.667 842.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7e7e",
      stroke: "none"
    },
    d: "M861 842L862 843L861 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M862 842L863 843L862 842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9",
      stroke: "none"
    },
    d: "M189 843L190 844L189 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c4c4c4",
      stroke: "none"
    },
    d: "M861 843L862 844L861 843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M185.333 844.667L185.667 845.333L185.333 844.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#292929",
      stroke: "none"
    },
    d: "M836 844L837 845L836 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M837 844L838 845L837 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222",
      stroke: "none"
    },
    d: "M859 844L860 845L859 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828",
      stroke: "none"
    },
    d: "M860 844L861 845L860 844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec",
      stroke: "none"
    },
    d: "M837 845L837 856L838 856L837 845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M181 846L182 847L181 846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M182 846L182 847L185 847L182 846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M185 846L186 847L185 846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9d9d",
      stroke: "none"
    },
    d: "M801.667 846.333L802.333 846.667L801.667 846.333M851 846L851 847L859 847L851 846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cccccc",
      stroke: "none"
    },
    d: "M181 847L182 848L181 847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec",
      stroke: "none"
    },
    d: "M179 848L180 849L179 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M799.667 848.333L800.333 848.667L799.667 848.333M803 848L804 849L803 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M804 848L805 849L804 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M179 849L180 850L179 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M804 849L805 850L804 849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M175 850L176 851L175 850z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#686868",
      stroke: "none"
    },
    d: "M176 850L176 851L179 851L176 850z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M179 850L180 851L179 850z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M804 850L805 851L804 850z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797",
      stroke: "none"
    },
    d: "M805.667 850.333L806.333 850.667L805.667 850.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434343",
      stroke: "none"
    },
    d: "M175 851L176 852L175 851z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M169 854L170 855L169 854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M170 854L171 855L170 854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a1a",
      stroke: "none"
    },
    d: "M171 854L172 855L171 854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M807 854L808 855L807 854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M808 854L809 855L808 854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M169 855L169 858L170 858L169 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M808 855L808 858L809 858L808 855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M835 856L836 857L835 856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M836 856L837 857L836 856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M167 858L168 859L167 858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M168 858L169 859L168 858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555",
      stroke: "none"
    },
    d: "M169 858L170 859L169 858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d4d4d4",
      stroke: "none"
    },
    d: "M808 858L809 859L808 858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M809.667 858.333L810.333 858.667L809.667 858.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383",
      stroke: "none"
    },
    d: "M833 858L834 859L833 858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M834 858L835 859L834 858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M167 859L167 862L168 862L167 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M833 859L833 862L834 862L833 859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383",
      stroke: "none"
    },
    d: "M168 862L169 863L168 862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f5f5f",
      stroke: "none"
    },
    d: "M169 862L170 863L169 862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383",
      stroke: "none"
    },
    d: "M176 862L176 863L181 863L176 862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M181 862L182 863L181 862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383",
      stroke: "none"
    },
    d: "M226 862L226 863L238 863L226 862M831.667 862.333L832.333 862.667L831.667 862.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M833 862L834 863L833 862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M169 863L170 864L169 863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cccccc",
      stroke: "none"
    },
    d: "M181 863L182 864L181 863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcbcbc",
      stroke: "none"
    },
    d: "M175 864L176 865L175 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M183 864L184 865L183 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d6d6d",
      stroke: "none"
    },
    d: "M223 864L224 865L223 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6b6b6b",
      stroke: "none"
    },
    d: "M800 864L801 865L800 864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M185 865L186 866L185 865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M239 865L239 868L240 868L239 865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M829 865L829 868L830 868L829 865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M185 866L186 867L185 866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M186 866L186 867L189 867L186 866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      stroke: "none"
    },
    d: "M189 866L190 867L189 866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M209 866L210 867L209 866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M210 866L210 867L218 867L210 866M799.667 866.333L800.333 866.667L799.667 866.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9",
      stroke: "none"
    },
    d: "M189.333 867.667L189.667 868.333L189.333 867.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040404",
      stroke: "none"
    },
    d: "M209.333 867.667L209.667 868.333L209.333 867.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M208 868L209 869L208 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M238 868L239 869L238 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040404",
      stroke: "none"
    },
    d: "M239 868L240 869L239 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M827 868L828 869L827 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M828 868L829 869L828 868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M193 869L194 870L193 869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eeeeee",
      stroke: "none"
    },
    d: "M193 870L194 871L193 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M194 870L194 871L203 871L194 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M203 870L204 871L203 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M235 870L236 871L235 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M236.667 870.333L237.333 870.667L236.667 870.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M811 870L812 871L811 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M812 870L813 871L812 870z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M235 871L236 872L235 871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M812 871L812 876L813 876L812 871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M232 872L232 873L235 873L232 872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M235 872L236 873L235 872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M827.667 872.333L828.333 872.667L827.667 872.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M829 872L829 876L830 876L829 872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M231 873L232 874L231 873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M230 874L231 875L230 874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M231 874L232 875L231 874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M226 876L226 877L230 877L226 876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M812 876L813 877L812 876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373737",
      stroke: "none"
    },
    d: "M828 876L829 877L828 876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M222 878L222 879L226 879L222 878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111111",
      stroke: "none"
    },
    d: "M762 878L763 879L762 878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M763.667 878.333L764.333 878.667L763.667 878.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      stroke: "none"
    },
    d: "M799 878L800 879L799 878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M800 878L801 879L800 878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M825.667 878.333L826.333 878.667L825.667 878.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M762.333 879.667L762.667 880.333L762.333 879.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a1a",
      stroke: "none"
    },
    d: "M218 880L218 881L222 881L218 880z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M815 880L816 881L815 880z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M824 880L825 881L824 880z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M770 881L770 886L771 886L770 881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M816 881L817 882L816 881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M215 882L216 883L215 882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d9d9d",
      stroke: "none"
    },
    d: "M216.667 882.333L217.333 882.667L216.667 882.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M816 882L817 883L816 882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#626262",
      stroke: "none"
    },
    d: "M817 882L817 883L821 883L817 882z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#858585",
      stroke: "none"
    },
    d: "M215 883L216 884L215 883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121",
      stroke: "none"
    },
    d: "M214 884L215 885L214 884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111111",
      stroke: "none"
    },
    d: "M215 884L216 885L215 884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M211 886L212 887L211 886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3a3a3",
      stroke: "none"
    },
    d: "M212.667 886.333L213.333 886.667L212.667 886.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec",
      stroke: "none"
    },
    d: "M770 886L771 887L770 886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M771.667 886.333L772.333 886.667L771.667 886.333M799.667 886.333L800.333 886.667L799.667 886.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M211 887L212 888L211 887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M209 888L210 889L209 888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828",
      stroke: "none"
    },
    d: "M210 888L211 889L210 888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M211 888L212 889L211 888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M209 889L210 890L209 889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d2d2",
      stroke: "none"
    },
    d: "M207 890L208 891L207 890z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaaaaa",
      stroke: "none"
    },
    d: "M208 890L209 891L208 890z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M209 890L210 891L209 890z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#555555",
      stroke: "none"
    },
    d: "M266 890L266 891L275 891L266 890z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d4d4d",
      stroke: "none"
    },
    d: "M275 890L276 891L275 890z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878",
      stroke: "none"
    },
    d: "M207 891L207 894L208 894L207 891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M275 891L276 892L275 891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M264 892L265 893L264 892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M265 892L266 893L265 892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M275 892L276 893L275 892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M276 892L277 893L276 892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959",
      stroke: "none"
    },
    d: "M277 892L278 893L277 892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d5d5d",
      stroke: "none"
    },
    d: "M796 892L797 893L796 892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313131",
      stroke: "none"
    },
    d: "M259 893L260 894L259 893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M207 894L208 895L207 894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M208 894L209 895L208 894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M209 894L210 895L209 894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111111",
      stroke: "none"
    },
    d: "M255 894L256 895L255 894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M256 894L256 895L259 895L256 894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070",
      stroke: "none"
    },
    d: "M259 894L260 895L259 894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M793.667 894.333L794.333 894.667L793.667 894.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M209 895L210 896L209 895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M255 895L256 896L255 895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M209 896L210 897L209 896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M210 896L211 897L210 896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M211 896L212 897L211 896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M216 896L216 897L223 897L216 896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M223 896L224 897L223 896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M250 896L250 897L255 897L250 896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M255 896L256 897L255 896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M791 896L792 897L791 896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M792 896L793 897L792 896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M211 897L212 898L211 897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      stroke: "none"
    },
    d: "M215 897L216 898L215 897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M223 897L224 898L223 897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M212 898L212 899L215 899L212 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M215 898L216 899L215 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M223 898L224 899L223 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M224 898L224 899L227 899L224 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b2b2b",
      stroke: "none"
    },
    d: "M227 898L228 899L227 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M246 898L246 899L250 899L246 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M274 898L274 899L277 899L274 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M277 898L278 899L277 898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484848",
      stroke: "none"
    },
    d: "M789.667 898.333L790.333 898.667L789.667 898.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M227 899L228 900L227 899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M227 900L228 901L227 900z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M228 900L228 901L233 901L228 900z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M233 900L234 901L233 900z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M240 900L240 901L246 901L240 900z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M271 900L272 901L271 900z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M272.667 900.333L273.333 900.667L272.667 900.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M271 901L272 902L271 901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M234 902L234 903L239 903L234 902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7e7e",
      stroke: "none"
    },
    d: "M239 902L240 903L239 902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M270 902L271 903L270 902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M271 902L272 903L271 902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M723 902L723 903L729 903L723 902M773 902L774 903L773 902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b3b3b",
      stroke: "none"
    },
    d: "M774 902L775 903L774 902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e9",
      stroke: "none"
    },
    d: "M774 903L774 908L775 908L774 903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M267 904L268 905L267 904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242",
      stroke: "none"
    },
    d: "M268.667 904.333L269.333 904.667L268.667 904.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb",
      stroke: "none"
    },
    d: "M267 905L268 906L267 905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f6f6",
      stroke: "none"
    },
    d: "M263 906L264 907L263 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M264 906L264 907L267 907L264 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M267 906L268 907L267 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M721 906L722 907L721 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M722 906L723 907L722 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M729 906L730 907L729 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M730 906L731 907L730 906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M787.667 906.333L788.333 906.667L787.667 906.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M263 907L264 908L263 907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M730 907L730 914L731 914L730 907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M786 907L787 908L786 907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M262 908L263 909L262 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3d",
      stroke: "none"
    },
    d: "M263 908L264 909L263 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9f9f9",
      stroke: "none"
    },
    d: "M774 908L775 909L774 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6b6b6",
      stroke: "none"
    },
    d: "M775 908L776 909L775 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4e4e4e",
      stroke: "none"
    },
    d: "M776 908L777 909L776 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6b6b6",
      stroke: "none"
    },
    d: "M785 908L786 909L785 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M786 908L787 909L786 908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M259 910L260 911L259 910z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcbcb",
      stroke: "none"
    },
    d: "M260 910L261 911L260 910z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M261 910L262 911L261 910z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M778 910L779 911L778 910z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      stroke: "none"
    },
    d: "M779 910L779 911L785 911L779 910z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cecece",
      stroke: "none"
    },
    d: "M259 911L260 912L259 911z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M778 911L779 912L778 911z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M258 912L259 913L258 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404040",
      stroke: "none"
    },
    d: "M259 912L260 913L259 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969",
      stroke: "none"
    },
    d: "M312 912L313 913L312 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M313 912L313 913L318 914L313 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#797979",
      stroke: "none"
    },
    d: "M317 912L318 913L317 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a4a4",
      stroke: "none"
    },
    d: "M759 912L760 913L759 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M760 912L761 913L760 912M777 912L778 913L777 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b4b4b4",
      stroke: "none"
    },
    d: "M778 912L779 913L778 912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#313131",
      stroke: "none"
    },
    d: "M758 913L758 916L759 916L758 913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d2d2",
      stroke: "none"
    },
    d: "M254 914L254 915L257 915L254 914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    d: "M257 914L258 915L257 914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M308 914L308 915L312 915L308 914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd",
      stroke: "none"
    },
    d: "M317 914L318 915L317 914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0b0b0",
      stroke: "none"
    },
    d: "M730 914L731 915L730 914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d2d2d",
      stroke: "none"
    },
    d: "M731.667 914.333L732.333 914.667L731.667 914.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M304 916L305 917L304 916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M305 916L305 917L308 917L305 916M318.667 916.333L319.333 916.667L318.667 916.333M757 916L758 917L757 916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bababa",
      stroke: "none"
    },
    d: "M758 916L759 917L758 916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6f6f6",
      stroke: "none"
    },
    d: "M251 918L252 919L251 918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9",
      stroke: "none"
    },
    d: "M252 918L253 919L252 918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b3b3b",
      stroke: "none"
    },
    d: "M253 918L254 919L253 918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M300 918L300 919L304 919L300 918M719.667 918.333L720.333 918.667L719.667 918.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M755 918L756 919L755 918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626",
      stroke: "none"
    },
    d: "M756 918L757 919L756 918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M251 919L251 922L252 922L251 919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M755 919L756 920L755 919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727272",
      stroke: "none"
    },
    d: "M296 920L297 921L296 920z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2a2a2",
      stroke: "none"
    },
    d: "M297 920L297 921L300 921L297 920z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d5d5d",
      stroke: "none"
    },
    d: "M318.667 920.333L319.333 920.667L318.667 920.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M730 920L731 921L730 920z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d5d5d",
      stroke: "none"
    },
    d: "M731.667 920.333L732.333 920.667L731.667 920.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a2a2a2",
      stroke: "none"
    },
    d: "M753.667 920.333L754.333 920.667L753.667 920.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M755 920L756 921L755 920z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#afafaf",
      stroke: "none"
    },
    d: "M317 921L317 924L318 924L317 921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M730 921L730 926L731 926L730 921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dfdfdf",
      stroke: "none"
    },
    d: "M250 922L251 923L250 922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M251 922L252 923L251 922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M292 922L292 923L296 923L292 922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M680 922L681 923L680 922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M681 922L681 923L686 923L681 922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M686 922L687 923L686 922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M751.667 922.333L752.333 922.667L751.667 922.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      stroke: "none"
    },
    d: "M680 923L680 926L681 926L680 923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M686 923L686 928L687 928L686 923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M751 923L752 924L751 923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M247 924L248 925L247 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M248.667 924.333L249.333 924.667L248.667 924.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M262 924L262 925L265 925L262 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M265 924L266 925L265 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M288 924L289 925L288 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M289 924L289 925L292 925L289 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M316 924L317 925L316 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M317 924L318 925L317 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M749.667 924.333L750.333 924.667L749.667 924.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fefefe",
      stroke: "none"
    },
    d: "M751 924L752 925L751 924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bababa",
      stroke: "none"
    },
    d: "M247 925L248 926L247 925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M287 925L288 926L287 925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M247 926L248 927L247 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M248 926L248 927L251 927L248 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#131313",
      stroke: "none"
    },
    d: "M251 926L252 927L251 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M258 926L258 927L262 927L258 926M266 926L266 927L271 927L266 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M271 926L272 927L271 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M283 926L284 927L283 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M284 926L284 927L287 927L284 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b1b1b",
      stroke: "none"
    },
    d: "M287 926L288 927L287 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M313 926L314 927L313 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      stroke: "none"
    },
    d: "M314.667 926.333L315.333 926.667L314.667 926.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M679 926L680 927L679 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M680 926L681 927L680 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M730 926L731 927L730 926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M731.667 926.333L732.333 926.667L731.667 926.333M747.667 926.333L748.333 926.667L747.667 926.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M251 927L252 928L251 927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M271 927L272 928L271 927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M283 927L284 928L283 927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M313 927L314 928L313 927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e5e5e5",
      stroke: "none"
    },
    d: "M251 928L252 929L251 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959595",
      stroke: "none"
    },
    d: "M252 928L252 929L258 929L252 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M271 928L272 929L271 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959595",
      stroke: "none"
    },
    d: "M272 928L272 929L283 929L272 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999",
      stroke: "none"
    },
    d: "M283 928L284 929L283 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      stroke: "none"
    },
    d: "M312 928L313 929L312 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M313 928L314 929L313 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M686 928L687 929L686 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959595",
      stroke: "none"
    },
    d: "M687 928L688 929L687 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M688 928L689 929L688 928z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9",
      stroke: "none"
    },
    d: "M688 929L688 944L689 944L688 929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M718 929L719 930L718 929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M308 930L308 931L312 931L308 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M358 930L359 931L358 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M359 930L360 931L359 930M717 930L718 931L717 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7d7d7d",
      stroke: "none"
    },
    d: "M718 930L719 931L718 930z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cbcbcb",
      stroke: "none"
    },
    d: "M358 931L359 932L358 931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M306.667 932.333L307.333 932.667L306.667 932.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M354 932L355 933L354 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M355 932L355 933L358 933L355 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M358 932L359 933L358 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M360 932L361 933L360 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M361 932L362 933L361 932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9b9b9b",
      stroke: "none"
    },
    d: "M305 933L306 934L305 933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d2d2",
      stroke: "none"
    },
    d: "M354 933L355 934L354 933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M361.333 933.667L361.667 934.333L361.333 933.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M304 934L305 935L304 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#949494",
      stroke: "none"
    },
    d: "M305 934L306 935L305 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M350 934L351 935L350 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M351 934L351 935L354 935L351 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d4d4d4",
      stroke: "none"
    },
    d: "M354 934L355 935L354 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M362.667 934.333L363.333 934.667L362.667 934.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M676 934L677 935L676 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M677 934L678 935L677 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M678 934L679 935L678 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M745 934L746 935L745 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4d4d4d",
      stroke: "none"
    },
    d: "M746 934L747 935L746 934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M350 935L351 936L350 935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M676 935L676 940L677 940L676 935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878",
      stroke: "none"
    },
    d: "M302.667 936.333L303.333 936.667L302.667 936.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "none"
    },
    d: "M348.667 936.333L349.333 936.667L348.667 936.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ededed",
      stroke: "none"
    },
    d: "M350 936L351 937L350 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "none"
    },
    d: "M733 936L734 937L733 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585858",
      stroke: "none"
    },
    d: "M734 936L735 937L734 936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "none"
    },
    d: "M743.667 936.333L744.333 936.667L743.667 936.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#949494",
      stroke: "none"
    },
    d: "M301 937L302 938L301 937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M734 937L734 940L735 940L734 937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M300 938L301 939L300 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M301 938L302 939L301 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M344 938L344 939L348 939L344 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M362.667 938.333L363.333 938.667L362.667 938.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M636 938L637 939L636 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M637 938L637 939L640 939L637 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M640 938L641 939L640 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#050505",
      stroke: "none"
    },
    d: "M715.667 938.333L716.333 938.667L715.667 938.333M737 938L737 939L742 939L737 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f4f4f",
      stroke: "none"
    },
    d: "M742 938L743 939L742 938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M361 939L361 944L362 944L361 939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c7c7c",
      stroke: "none"
    },
    d: "M636 939L637 940L636 939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M640 939L641 940L640 939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M342 940L343 941L342 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M343 940L344 941L343 940M635 940L636 941L635 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M636 940L637 941L636 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M640 940L641 941L640 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M641 940L642 941L641 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M642 940L643 941L642 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M675 940L676 941L675 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      stroke: "none"
    },
    d: "M676 940L677 941L676 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M713.667 940.333L714.333 940.667L713.667 940.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M734 940L735 941L734 940z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M735.667 940.333L736.333 940.667L735.667 940.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      stroke: "none"
    },
    d: "M342 941L343 942L342 941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M642.333 941.667L642.667 942.333L642.333 941.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M298.667 942.333L299.333 942.667L298.667 942.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282828",
      stroke: "none"
    },
    d: "M341 942L342 943L341 942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M296.667 944.333L297.333 944.667L296.667 944.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M336 944L336 945L340 945L336 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M360 944L361 945L360 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M361 944L362 945L361 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    d: "M402 944L403 945L402 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M403 944L403 945L408 945L403 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#030303",
      stroke: "none"
    },
    d: "M408 944L409 945L408 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M643 944L644 945L643 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545",
      stroke: "none"
    },
    d: "M644 944L645 945L644 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aeaeae",
      stroke: "none"
    },
    d: "M686 944L687 945L686 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M687 944L688 945L687 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M688 944L689 945L688 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M708 944L709 945L708 944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M709.667 944.333L710.333 944.667L709.667 944.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M402 945L403 946L402 945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M408.333 945.667L408.667 946.333L408.333 945.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M644.333 945.667L644.667 946.333L644.333 945.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M686 945L686 952L687 952L686 945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040404",
      stroke: "none"
    },
    d: "M708.333 945.667L708.667 946.333L708.333 945.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M358 946L359 947L358 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M359 946L360 947L359 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfbfb",
      stroke: "none"
    },
    d: "M402 946L403 947L402 946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f3f3",
      stroke: "none"
    },
    d: "M334 947L335 948L334 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M357 947L358 948L357 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282",
      stroke: "none"
    },
    d: "M632 947L632 951L633 951L632 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M704 947L705 948L704 947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M294.667 948.333L295.333 948.667L294.667 948.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M304 948L304 949L312 949L304 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M330 948L331 949L330 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M331 948L331 949L334 949L331 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M334 948L335 949L334 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8b8b8b",
      stroke: "none"
    },
    d: "M356 948L357 949L356 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M357 948L358 949L357 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    d: "M398 948L399 949L398 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M399 948L400 949L399 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M672 948L673 949L672 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M673.667 948.333L674.333 948.667L673.667 948.333M703 948L704 949L703 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      stroke: "none"
    },
    d: "M704 948L705 949L704 948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      stroke: "none"
    },
    d: "M330 949L331 950L330 949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888",
      stroke: "none"
    },
    d: "M398 949L399 950L398 949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#404040",
      stroke: "none"
    },
    d: "M672 949L672 956L673 956L672 949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M329 950L330 951L329 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393939",
      stroke: "none"
    },
    d: "M354 950L355 951L354 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f0f0f",
      stroke: "none"
    },
    d: "M355 950L356 951L355 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M398 950L399 951L398 950z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      stroke: "none"
    },
    d: "M353 951L354 952L353 951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949",
      stroke: "none"
    },
    d: "M590 951L591 952L590 951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M596 951L596 955L597 955L596 951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M630 951L630 956L631 956L630 951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M300.667 952.333L301.333 952.667L300.667 952.333M322 952L322 953L326 953L322 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M352 952L353 953L352 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686",
      stroke: "none"
    },
    d: "M353 952L354 953L353 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M392 952L392 953L396 953L392 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515",
      stroke: "none"
    },
    d: "M450 952L451 953L450 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M451 952L452 953L451 952M589 952L590 953L589 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797",
      stroke: "none"
    },
    d: "M590 952L591 953L590 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M686 952L687 953L686 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M687 952L688 953L687 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d5d5d",
      stroke: "none"
    },
    d: "M688 952L689 953L688 952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M452.333 953.667L452.667 954.333L452.333 953.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d9d9d9",
      stroke: "none"
    },
    d: "M688 953L688 960L689 960L688 953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393939",
      stroke: "none"
    },
    d: "M350 954L351 955L350 954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M351 954L352 955L351 954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M408 954L409 955L408 954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M409 954L410 955L409 954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M702 954L703 955L702 954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M349 955L350 956L349 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "none"
    },
    d: "M390 955L391 956L390 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M408 955L409 956L408 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M448 955L449 956L448 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M456 955L456 964L457 964L456 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M598 955L598 960L599 960L598 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121212",
      stroke: "none"
    },
    d: "M700 955L701 956L700 955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M348 956L349 957L348 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888",
      stroke: "none"
    },
    d: "M349 956L350 957L349 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M388.667 956.333L389.333 956.667L388.667 956.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M390 956L391 957L390 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M406.667 956.333L407.333 956.667L406.667 956.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#040404",
      stroke: "none"
    },
    d: "M408 956L409 957L408 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171717",
      stroke: "none"
    },
    d: "M446 956L447 957L446 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M447 956L448 957L447 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      stroke: "none"
    },
    d: "M448 956L449 957L448 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M498 956L499 957L498 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M499 956L499 957L502 957L499 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M502 956L503 957L502 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M544 956L545 957L544 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M545 956L545 957L550 957L545 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e2e",
      stroke: "none"
    },
    d: "M550 956L551 957L550 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M586 956L587 957L586 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M587.667 956.333L588.333 956.667L587.667 956.333M629 956L630 957L629 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      stroke: "none"
    },
    d: "M630 956L631 957L630 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      stroke: "none"
    },
    d: "M642 956L643 957L642 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M671 956L672 957L671 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d",
      stroke: "none"
    },
    d: "M672 956L673 957L672 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M699 956L700 957L699 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M700 956L701 957L700 956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M498.333 957.667L498.667 958.333L498.333 957.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M502 957L502 960L503 960L502 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M544 957L545 958L544 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#747474",
      stroke: "none"
    },
    d: "M550 957L550 972L551 972L550 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#505050",
      stroke: "none"
    },
    d: "M586 957L586 960L587 960L586 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M628 957L628 963L629 963L628 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0e0e0e",
      stroke: "none"
    },
    d: "M642 957L642 963L643 963L642 957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      stroke: "none"
    },
    d: "M544 958L545 959L544 958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848484",
      stroke: "none"
    },
    d: "M698 958L699 959L698 958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9c9c9c",
      stroke: "none"
    },
    d: "M386 959L387 960L386 959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bbbbbb",
      stroke: "none"
    },
    d: "M444 959L445 960L444 959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      stroke: "none"
    },
    d: "M496 959L497 960L496 959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989898",
      stroke: "none"
    },
    d: "M542 959L543 960L542 959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474747",
      stroke: "none"
    },
    d: "M668 959L669 960L668 959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M692 959L693 960L692 959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M345 960L346 961L345 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M346.667 960.333L347.333 960.667L346.667 960.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M384.667 960.333L385.333 960.667L384.667 960.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M386 960L387 961L386 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a0a0a0",
      stroke: "none"
    },
    d: "M404 960L405 961L404 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M405 960L406 961L405 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#181818",
      stroke: "none"
    },
    d: "M442 960L443 961L442 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M443 960L444 961L443 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d5d5d5",
      stroke: "none"
    },
    d: "M444 960L445 961L444 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575757",
      stroke: "none"
    },
    d: "M494 960L495 961L494 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M495 960L496 961L495 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M496 960L497 961L496 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#767676",
      stroke: "none"
    },
    d: "M502 960L503 961L502 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M503 960L504 961L503 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a0a0a",
      stroke: "none"
    },
    d: "M540 960L541 961L540 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M541 960L542 961L541 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M542 960L543 961L542 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M585 960L586 961L585 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#919191",
      stroke: "none"
    },
    d: "M586 960L587 961L586 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      stroke: "none"
    },
    d: "M596 960L597 961L596 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M597 960L598 961L597 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      stroke: "none"
    },
    d: "M598 960L599 961L598 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M667 960L668 961L667 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8c8c",
      stroke: "none"
    },
    d: "M668 960L669 961L668 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7e7e7",
      stroke: "none"
    },
    d: "M688 960L689 961L688 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#606060",
      stroke: "none"
    },
    d: "M689 960L689 961L692 961L689 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373",
      stroke: "none"
    },
    d: "M692 960L693 961L692 960z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dddddd",
      stroke: "none"
    },
    d: "M345.333 961.667L345.667 962.333L345.333 961.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      stroke: "none"
    },
    d: "M404 961L405 962L404 961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8e8e8",
      stroke: "none"
    },
    d: "M494.333 961.667L494.667 962.333L494.333 961.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M540 961L540 964L541 964L540 961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414141",
      stroke: "none"
    },
    d: "M596 961L596 970L597 970L596 961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M403 962L404 963L403 962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aeaeae",
      stroke: "none"
    },
    d: "M666 962L667 963L666 962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c2c2c2",
      stroke: "none"
    },
    d: "M440 963L441 964L440 963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6c6c",
      stroke: "none"
    },
    d: "M492 963L493 964L492 963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M626 963L626 967L627 967L626 963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M640 963L640 980L641 980L640 963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3c3c3c",
      stroke: "none"
    },
    d: "M378 964L379 965L378 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M379 964L380 965L379 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a5a5",
      stroke: "none"
    },
    d: "M400.667 964.333L401.333 964.667L400.667 964.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M438 964L439 965L438 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M439 964L440 965L439 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M440 964L441 965L440 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a5a5",
      stroke: "none"
    },
    d: "M454.667 964.333L455.333 964.667L454.667 964.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M456 964L457 965L456 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#545454",
      stroke: "none"
    },
    d: "M490 964L491 965L490 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M491 964L492 965L491 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M492 964L493 965L492 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M538 964L539 965L538 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M539 964L540 965L539 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6c6c6c",
      stroke: "none"
    },
    d: "M540 964L541 965L540 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M582 964L583 965L582 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a5a5a",
      stroke: "none"
    },
    d: "M583.667 964.333L584.333 964.667L583.667 964.333M659 964L659 965L663 965L659 964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9a9a9",
      stroke: "none"
    },
    d: "M378.333 965.667L378.667 966.333L378.333 965.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef",
      stroke: "none"
    },
    d: "M490 965L490 968L491 968L490 965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M538.333 965.667L538.667 966.333L538.333 965.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#565656",
      stroke: "none"
    },
    d: "M582 965L582 968L583 968L582 965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0b0b0",
      stroke: "none"
    },
    d: "M374 967L375 968L374 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M436 967L437 968L436 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M502 967L502 972L503 972L502 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232323",
      stroke: "none"
    },
    d: "M536 967L536 970L537 970L536 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f8f8f",
      stroke: "none"
    },
    d: "M624 967L624 972L625 972L624 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5b5b5b",
      stroke: "none"
    },
    d: "M656 967L657 968L656 967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f2f2f2",
      stroke: "none"
    },
    d: "M341 968L342 969L341 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acacac",
      stroke: "none"
    },
    d: "M342.667 968.333L343.333 968.667L342.667 968.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M354 968L355 969L354 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M355 968L355 969L374 969L355 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M374 968L375 969L374 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acacac",
      stroke: "none"
    },
    d: "M398.667 968.333L399.333 968.667L398.667 968.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M434 968L435 969L434 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M435 968L436 969L435 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb",
      stroke: "none"
    },
    d: "M436 968L437 969L436 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c6c6c6",
      stroke: "none"
    },
    d: "M452 968L453 969L452 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acacac",
      stroke: "none"
    },
    d: "M453 968L454 969L453 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252525",
      stroke: "none"
    },
    d: "M488 968L489 969L488 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M489 968L490 969L489 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4",
      stroke: "none"
    },
    d: "M490 968L491 969L490 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M581 968L582 969L581 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d",
      stroke: "none"
    },
    d: "M582 968L583 969L582 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M655 968L656 969L655 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#909090",
      stroke: "none"
    },
    d: "M656 968L657 969L656 968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M341 969L341 972L342 972L341 969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2d2d2",
      stroke: "none"
    },
    d: "M354 969L355 970L354 969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M452 969L453 970L452 969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373",
      stroke: "none"
    },
    d: "M488.333 969.667L488.667 970.333L488.333 969.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#101010",
      stroke: "none"
    },
    d: "M353 970L354 971L353 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f7f7f7",
      stroke: "none"
    },
    d: "M354 970L355 971L354 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f0f0f",
      stroke: "none"
    },
    d: "M452 970L453 971L452 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M536 970L537 971L536 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cacaca",
      stroke: "none"
    },
    d: "M594 970L595 971L594 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M595 970L596 971L595 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M596 970L597 971L596 970z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8d8d8",
      stroke: "none"
    },
    d: "M350 971L351 972L350 971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0d0d0",
      stroke: "none"
    },
    d: "M432 971L433 972L432 971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      stroke: "none"
    },
    d: "M486 971L487 972L486 971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5a5a5",
      stroke: "none"
    },
    d: "M534 971L534 975L535 975L534 971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbdbd",
      stroke: "none"
    },
    d: "M594 971L594 976L595 976L594 971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M341 972L342 973L341 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M342 972L342 973L350 973L342 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e4e4e4",
      stroke: "none"
    },
    d: "M350 972L351 973L350 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M430 972L431 973L430 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M431 972L432 973L431 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dedede",
      stroke: "none"
    },
    d: "M432 972L433 973L432 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M484 972L485 973L484 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M485 972L486 973L485 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8f8f8",
      stroke: "none"
    },
    d: "M486 972L487 973L486 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3e3e3",
      stroke: "none"
    },
    d: "M500 972L501 973L500 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3b3b3",
      stroke: "none"
    },
    d: "M501 972L502 973L501 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M502 972L503 973L502 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3b3b3",
      stroke: "none"
    },
    d: "M548.667 972.333L549.333 972.667L548.667 972.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#515151",
      stroke: "none"
    },
    d: "M550 972L551 973L550 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1c1c1c",
      stroke: "none"
    },
    d: "M578 972L579 973L578 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M579.667 972.333L580.333 972.667L579.667 972.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#060606",
      stroke: "none"
    },
    d: "M622 972L623 973L622 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4c4c4c",
      stroke: "none"
    },
    d: "M623 972L624 973L623 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M624 972L625 973L624 972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7a7a7a",
      stroke: "none"
    },
    d: "M484.333 973.667L484.667 974.333L484.333 973.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d5d5d",
      stroke: "none"
    },
    d: "M578 973L578 976L579 976L578 973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414",
      stroke: "none"
    },
    d: "M622.333 973.667L622.667 974.333L622.333 973.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8e8e8e",
      stroke: "none"
    },
    d: "M394 974L395 975L394 974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373737",
      stroke: "none"
    },
    d: "M395 974L396 975L395 974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M448 974L449 975L448 974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#373737",
      stroke: "none"
    },
    d: "M449 974L450 975L449 974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d6d6d6",
      stroke: "none"
    },
    d: "M428 975L429 976L428 975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a",
      stroke: "none"
    },
    d: "M448 975L449 976L448 975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfcfc",
      stroke: "none"
    },
    d: "M482 975L482 979L483 979L482 975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2a2a2a",
      stroke: "none"
    },
    d: "M532 975L533 976L532 975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1a1a1a",
      stroke: "none"
    },
    d: "M618 975L619 976L618 975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M426 976L427 977L426 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M427 976L428 977L427 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e1e1e1",
      stroke: "none"
    },
    d: "M428 976L429 977L428 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M446.667 976.333L447.333 976.667L446.667 976.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363636",
      stroke: "none"
    },
    d: "M448 976L449 977L448 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M498 976L499 977L498 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M499 976L500 977L499 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f",
      stroke: "none"
    },
    d: "M530 976L531 977L530 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M531 976L532 977L531 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M532 976L533 977L532 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d7d7d7",
      stroke: "none"
    },
    d: "M546 976L547 977L546 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M547 976L548 977L547 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M577 976L578 977L577 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898989",
      stroke: "none"
    },
    d: "M578 976L579 977L578 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M592 976L593 977L592 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M593 976L594 977L593 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a8a8a",
      stroke: "none"
    },
    d: "M594 976L595 977L594 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#090909",
      stroke: "none"
    },
    d: "M614 976L615 977L614 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M615 976L615 977L618 977L615 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959",
      stroke: "none"
    },
    d: "M618 976L619 977L618 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464646",
      stroke: "none"
    },
    d: "M651 976L651 977L655 977L651 976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d1d1d",
      stroke: "none"
    },
    d: "M498 977L498 980L499 980L498 977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#acacac",
      stroke: "none"
    },
    d: "M530 977L530 980L531 980L530 977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e6e6e",
      stroke: "none"
    },
    d: "M546 977L546 980L547 980L546 977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a3a3a",
      stroke: "none"
    },
    d: "M592 977L592 991L593 991L592 977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121",
      stroke: "none"
    },
    d: "M614 977L615 978L614 977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3e3e3e",
      stroke: "none"
    },
    d: "M392.667 978.333L393.333 978.667L392.667 978.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c9c9c9",
      stroke: "none"
    },
    d: "M614 978L615 979L614 978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#adadad",
      stroke: "none"
    },
    d: "M650 978L651 979L650 978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#616161",
      stroke: "none"
    },
    d: "M422 979L423 980L422 979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7f7f7f",
      stroke: "none"
    },
    d: "M480 979L481 980L480 979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aaaaaa",
      stroke: "none"
    },
    d: "M608 979L609 980L608 979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M644 979L645 980L644 979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e1e1e",
      stroke: "none"
    },
    d: "M406 980L407 981L406 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M407 980L407 981L422 981L407 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#888888",
      stroke: "none"
    },
    d: "M422 980L423 981L422 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d1d1d1",
      stroke: "none"
    },
    d: "M444 980L445 981L444 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M445 980L446 981L445 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M478.667 980.333L479.333 980.667L478.667 980.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9f9f9f",
      stroke: "none"
    },
    d: "M480 980L481 981L480 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M496.667 980.333L497.333 980.667L496.667 980.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161616",
      stroke: "none"
    },
    d: "M498 980L499 981L498 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      stroke: "none"
    },
    d: "M528 980L529 981L528 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M529 980L530 981L529 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c1c1c1",
      stroke: "none"
    },
    d: "M530 980L531 981L530 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M544.667 980.333L545.333 980.667L544.667 980.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      stroke: "none"
    },
    d: "M546 980L547 981L546 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M574 980L575 981L574 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M575.667 980.333L576.333 980.667L575.667 980.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0b0b0b",
      stroke: "none"
    },
    d: "M606 980L607 981L606 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M607 980L608 981L607 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfbfbf",
      stroke: "none"
    },
    d: "M608 980L609 981L608 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M640 980L641 981L640 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f3f",
      stroke: "none"
    },
    d: "M641 980L641 981L644 981L641 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292",
      stroke: "none"
    },
    d: "M644 980L645 981L644 980z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7c7c7c",
      stroke: "none"
    },
    d: "M406 981L407 982L406 981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M444 981L444 984L445 984L444 981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#303030",
      stroke: "none"
    },
    d: "M528 981L529 982L528 981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646464",
      stroke: "none"
    },
    d: "M574.333 981.667L574.667 982.333L574.333 981.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e2e",
      stroke: "none"
    },
    d: "M606 981L606 984L607 984L606 981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dcdcdc",
      stroke: "none"
    },
    d: "M406 982L407 983L406 982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8c8c8",
      stroke: "none"
    },
    d: "M528 982L529 983L528 982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686",
      stroke: "none"
    },
    d: "M476 983L477 984L476 983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3b3b3",
      stroke: "none"
    },
    d: "M526 983L526 987L527 987L526 983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      stroke: "none"
    },
    d: "M570 983L571 984L570 983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M392 984L392 985L396 985L392 984M398.667 984.333L399.333 984.667L398.667 984.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M442.667 984.333L443.333 984.667L442.667 984.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353535",
      stroke: "none"
    },
    d: "M444 984L445 985L444 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1f1f1f",
      stroke: "none"
    },
    d: "M472 984L473 985L472 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M473 984L473 985L476 985L473 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a1a1",
      stroke: "none"
    },
    d: "M476 984L477 985L476 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cccccc",
      stroke: "none"
    },
    d: "M494 984L495 985L494 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M495 984L496 985L495 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191919",
      stroke: "none"
    },
    d: "M566 984L567 985L566 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M567 984L567 985L570 985L567 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a8a8a",
      stroke: "none"
    },
    d: "M570 984L571 985L570 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272727",
      stroke: "none"
    },
    d: "M604 984L605 985L604 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838",
      stroke: "none"
    },
    d: "M605 984L606 985L605 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5c5c5c",
      stroke: "none"
    },
    d: "M606 984L607 985L606 984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d",
      stroke: "none"
    },
    d: "M472.333 985.667L472.667 986.333L472.333 985.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#171717",
      stroke: "none"
    },
    d: "M494 985L494 990L495 990L494 985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717171",
      stroke: "none"
    },
    d: "M566.333 985.667L566.667 986.333L566.333 985.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b1b1b1",
      stroke: "none"
    },
    d: "M604.333 985.667L604.667 986.333L604.333 985.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M468 987L469 988L468 987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b9b9b9",
      stroke: "none"
    },
    d: "M522 987L523 988L522 987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b7b7b7",
      stroke: "none"
    },
    d: "M600 987L601 988L600 987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121",
      stroke: "none"
    },
    d: "M456 988L457 989L456 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M457 988L457 989L468 989L457 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M468 988L469 989L468 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d0d0d",
      stroke: "none"
    },
    d: "M516 988L517 989L516 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M517 988L517 989L522 989L517 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c7c7c7",
      stroke: "none"
    },
    d: "M522 988L523 989L522 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M557 988L557 989L561 989L557 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252525",
      stroke: "none"
    },
    d: "M596 988L597 989L596 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323232",
      stroke: "none"
    },
    d: "M597 988L597 989L600 989L597 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      stroke: "none"
    },
    d: "M600 988L601 989L600 988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M456.333 989.667L456.667 990.333L456.333 989.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#444444",
      stroke: "none"
    },
    d: "M516 989L517 990L516 989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M556 989L556 994L557 994L556 989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bebebe",
      stroke: "none"
    },
    d: "M596.333 989.667L596.667 990.333L596.333 989.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M440 990L441 991L440 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#525252",
      stroke: "none"
    },
    d: "M441 990L442 991L441 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b6b6b6",
      stroke: "none"
    },
    d: "M492 990L493 991L492 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#525252",
      stroke: "none"
    },
    d: "M493 990L494 991L493 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#070707",
      stroke: "none"
    },
    d: "M494 990L495 991L494 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c3c3c3",
      stroke: "none"
    },
    d: "M516 990L517 991L516 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797",
      stroke: "none"
    },
    d: "M542 990L543 991L542 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#525252",
      stroke: "none"
    },
    d: "M543 990L544 991L543 990z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3d",
      stroke: "none"
    },
    d: "M440 991L440 996L441 996L440 991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M492 991L493 992L492 991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#525252",
      stroke: "none"
    },
    d: "M508 991L509 992L508 991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676767",
      stroke: "none"
    },
    d: "M542 991L542 999L543 999L542 991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b2b2b",
      stroke: "none"
    },
    d: "M450 992L450 993L454 993L450 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7b7b7b",
      stroke: "none"
    },
    d: "M492 992L493 993L492 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M506 992L507 993L506 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b2b2b",
      stroke: "none"
    },
    d: "M507 992L508 993L507 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6f6f6f",
      stroke: "none"
    },
    d: "M508 992L509 993L508 992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d4d4d4",
      stroke: "none"
    },
    d: "M506.333 993.667L506.667 994.333L506.333 993.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M556 994L557 995L556 994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b5b5b5",
      stroke: "none"
    },
    d: "M448 995L449 996L448 995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dbdbdb",
      stroke: "none"
    },
    d: "M502 995L503 996L502 995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#080808",
      stroke: "none"
    },
    d: "M552 995L553 996L552 995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#585858",
      stroke: "none"
    },
    d: "M440 996L441 997L440 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M441 996L441 997L448 997L441 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c0c0c0",
      stroke: "none"
    },
    d: "M448 996L449 997L448 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020",
      stroke: "none"
    },
    d: "M498 996L499 997L498 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M499 996L499 997L502 997L499 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      stroke: "none"
    },
    d: "M502 996L503 997L502 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202",
      stroke: "none"
    },
    d: "M548 996L549 997L548 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424",
      stroke: "none"
    },
    d: "M549 996L549 997L552 997L549 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2b2b2b",
      stroke: "none"
    },
    d: "M552 996L553 997L552 996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e2e2e2",
      stroke: "none"
    },
    d: "M498.333 997.667L498.667 998.333L498.333 997.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f0f0f",
      stroke: "none"
    },
    d: "M548 997L549 998L548 997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5d5d5d",
      stroke: "none"
    },
    d: "M492 998L493 999L492 998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a6a6",
      stroke: "none"
    },
    d: "M548 998L549 999L548 998z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.add3ef96d4e00f729c238d65c3830279.svg";
export { ForwardRef as ReactComponent };